{
  "common": {
    "no_access": "Vous n'avez pas accès à ce module"
  },
  "settings": {
    "calendar": {
      "calendar_settings": "Paramètres du calendrier",
      "settings": "Paramètres",
      "select_calendar_type": "Sélectionner le type de calendrier",
      "add_new_calendar_group": "Ajouter un nouveau groupe de calendriers",
      "add_new_equipment": "Ajouter un équipement",
      "new_calendar": "Nouveau calendrier",
      "calendar_group_description": "Utilisez les groupes pour organiser et regrouper efficacement plusieurs calendriers.",
      "group": "Groupe",
      "manage_your_calendars_and_groups": "Gérer vos calendriers et vos groupes",
      "groups": "Groupes",
      "create_group": "Créer un groupe",
      "create_calendar": "Créer un calendrier",
      "calendar_name": "Nom du calendrier",
      "group_duration": "Durée du groupe",
      "calendar_type": "saisir",
      "action": "Action",
      "round_robin": "Round robin",
      "event": "Événement",
      "group_name": "Nom du groupe",
      "room_name": "Nom de la salle",
      "group_description": "Description du groupe",
      "calendar_url": "URL du calendrier",
      "calendars": "Calendriers",
      "date_updated": "Date de mise à jour",
      "status": "Statut",
      "action_dropdown": "Liste déroulante des actions",
      "calendar_list": "Services associés à",
      "edit": "Modifier",
      "duplicate": "Dupliquer",
      "copy_embed_code": "Copier le code d'intégration",
      "copy_permanent_link": "Copier le lien permanent",
      "copy_new_slug_link": "Copier le lien de planification",
      "copy_scheduling_link": "Copier le lien de planification (ancienne version obsolète)",
      "deactivate_calendar": "Désactiver le calendrier",
      "move_to_group": "Déplacer vers le groupe",
      "delete_calendar": "Supprimer le calendrier",
      "delete_group": "Supprimer",
      "delete_this_group": "Supprimer ce groupe",
      "activate_calendar": "Activer le calendrier",
      "duration": "durée",
      "multiple_durations": "Plusieurs",
      "all": "Tout",
      "draft": "Brouillon",
      "inactive": "inactif",
      "active": "Actif",
      "actions": "activités",
      "rearrange_calendars": "Réorganiser les calendriers",
      "deactivate_all_calendars_in_group": "Désactiver tous les calendriers du groupe",
      "activate_all_calendars_in_group": "Activer tous les calendriers du groupe",
      "no_groups_found": "Aucun groupe de calendriers ne correspond à votre recherche.",
      "no_groups_in_location": "Groupe Ajoutez des calendriers à un groupe et une personne comprend plusieurs calendriers.",
      "no_calendars_found": "Commencez à utiliser les calendriers en créant un calendrier.",
      "no_calendars_found_search": "Aucun calendrier ne correspond à votre recherche.",
      "delete_calendar_message": "Vous êtes sur le point de supprimer le calendrier. Si vous cliquez sur Supprimer, tous les rendez-vous seront également supprimés.",
      "delete_calendar_message_title": "Supprimer ce calendrier ?",
      "duplicate_calendar_message": "Vous êtes sur le point de dupliquer le calendrier. Cela créera un nouveau calendrier avec les mêmes paramètres que le calendrier sélectionné.",
      "duplicate_calendar_message_title": "Dupliquer ce calendrier ?",
      "no_calendars_found_title": "Aucun calendrier trouvé",
      "no_groups_in_location_title": "Aucun groupe n'a été trouvé",
      "delete_group_confirmation_title": "Supprimer ce groupe ?",
      "delete_group_confirmation": "Voulez-vous vraiment supprimer le groupe sélectionné ?",
      "delete_group_confirmation_checkbox_title": "Supprimer les calendriers et les rendez-vous associés",
      "delete_group_confirmation_checkbox_description": "Sélectionner cette option supprimera également les calendriers de ce groupe, ainsi que tous les rendez-vous de ces calendriers.",
      "group_status_message_title": "{status} groupe et tous les calendriers associés ?",
      "calendar_status_message_title": "{status} ce calendrier ?",
      "calendar_status_message": "Vous êtes sur le point de {status} le calendrier.",
      "group_status_active_message": "Voulez-vous vraiment activer ce groupe ? Tous les calendriers du groupe seront également activés et disponibles pour la réservation.",
      "group_status_inactive_message": "Voulez-vous vraiment désactiver ce groupe ? Tous les calendriers du groupe seront également désactivés et disponibles pour la réservation.",
      "coming_soon": "À venir…",
      "select": "Sélectionner",
      "15mins": "15 min",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "create": "Créer",
      "select_calendar_group": "Sélectionner un groupe de calendriers",
      "move_calendar_confirmation": "L'ancien lien cessera de fonctionner une fois que vous aurez procédé à ce changement. Veuillez confirmer en cochant la case.",
      "previously_called_unassigned": " (Précédemment désigné comme non assigné)",
      "scheduling_type": "Sélectionner le type de calendrier",
      "scheduling_type_description": "Configurez un saisir",
      "service_menu_name": "Nom du menu de services",
      "template": "Modèle",
      "select_template": "Sélectionner un modèle",
      "group_url": "URL du groupe",
      "template_description": "Vous avez maintenant le choix de sélectionner les modèles Classic ou Neo pour la vue de groupe.",
      "rooms": "Salles",
      "rooms_name": "Nom",
      "rooms_description": "Description",
      "rooms_modal_description": "Ajoutez ou modifiez une salle.",
      "rooms_capacity": "Capacité totale",
      "no_rooms_in_location_title": "Aucune salle trouvée",
      "no_rooms_in_location": "Aucune salle n'a été trouvée à cet endroit",
      "no_equipments_in_location": "Aucun équipement n'a été trouvé à cet endroit",
      "equipments": "Équipements",
      "equipment_name": "Nom",
      "equipment_name_search": "Nom de l'équipement",
      "equipment_description": "Description",
      "equipment_modal_description": "Ajoutez ou modifiez un équipement.",
      "add_equipment": "Ajouter/Modifier un équipement",
      "add_room": "Ajouter/Modifier une salle",
      "equipment_quantity": "Quantité totale",
      "equipment_outOfService": "Quantité hors service",
      "no_equipments_in_location_title": "Aucun équipement trouvé",
      "delete_this_equipment": "Supprimer cet équipement",
      "delete_this_rooms": "Supprimer cette salle",
      "delete_equipment_confirmation": "Voulez-vous vraiment supprimer cet équipement ? Il sera également supprimé de tous les calendriers liés.",
      "delete_rooms_confirmation": "Voulez-vous vraiment supprimer cette salle ? Elle sera également supprimée de tous les calendriers liés.",
      "add_new_calendar_equipments": "Ajouter un équipement",
      "no_equipments_found": "Aucun équipement ne correspond à votre recherche.",
      "no_rooms_found": "Aucune salle ne correspond à votre recherche.",
      "add_new_calendar_rooms": "Ajouter une salle",
      "rooms_disable": "Désactiver la salle",
      "equipments_disable": "Désactiver l'équipement",
      "equipments_activate": "Activer l'équipement",
      "rooms_activate": "Activer la salle",
      "create_equipments": "Créer un équipement",
      "create_rooms": "Créer une salle",
      "select_calendar_rooms_title": "Sélectionner un calendrier",
      "select_calendar_rooms_description": "Vous pouvez sélectionner plusieurs calendriers à associer aux salles.",
      "select_calendar_equipments_title": "Sélectionner un calendrier",
      "select_calendar_equipments_description": "Vous pouvez sélectionner un calendrier à associer à l'équipement.",
      "disable_equipment_title": "{status} l'équipement",
      "disable_room_title": "{status} la salle",
      "equipments_status_message": "Voulez-vous vraiment {status} cet équipement ?",
      "rooms_status_message": "Voulez-vous vraiment {status} cette salle ?",
      "calendar_resource_disclaimer": "Cela pourrait affecter la disponibilité sur les calendriers de service associés.",
      "equipment_disclaimer": "Remarque : Le fait d'activer l'équipement ultérieurement le reconnectera automatiquement aux calendriers auxquels il est associé",
      "room_disclaimer": "Remarque : Le fait d'activer la salle ultérieurement la reconnectera automatiquement aux calendriers auxquels elle est associée",
      "equipment_tab_name": "Équipements",
      "rooms_tab_name": "Salles",
      "manage_your_rooms": "Gérez les salles de votre entreprise ici",
      "manage_your_equipments": "Gérez les équipements de votre entreprise ici",
      "select_service_calendar_description_equipments": "Vous pouvez sélectionner plusieurs calendriers de service à associer à l'équipement.",
      "select_service_calendar_description_rooms": "Vous pouvez sélectionner plusieurs calendriers de service à associer aux salles.",
      "service_menus": "Menu des services",
      "manage_your_calendars_groups_and_service_menus": "Gérer vos calendriers, vos groupes et votre menu de services",
      "new_service_menu": "Créer un menu des services",
      "deactivate_service_menu": "Désactiver le menu des services",
      "delete_service_menu": "Supprimer ce menu des services",
      "delete_service_menu_confirmation": "Voulez-vous vraiment supprimer ce menu de services ?",
      "service_menu_status_message_title": "{status} ce menu des services ?",
      "service_menu_status_message": "Vous êtes sur le point de {status} le menu des services.",
      "no_service_menus_in_location_title": "Créez votre menu des services personnalisé",
      "add_new_service_menu": "Ajouter un nouveau menu des services",
      "no_service_menus_in_location": "Commencez par créer un menu de services et ajoutez-y des groupes",
      "no_service_menu_found": "Aucun menu des services n'a été trouvé",
      "no_service_menu_found_desc": "Aucun menu de services ne correspond à votre recherche.",
      "apply": "Appliquer",
      "troubleshoot_calendar": "Résoudre le calendrier",
      "round_robin_booking": "Round robin",
      "round_robin_description": "Répartit les rendez-vous entre les membres d'équipe selon un roulement.",
      "round_robin_example": "Ex. : appels commerciaux, sessions d'intégration.",
      "unassigned_booking": "Calendrier d'événements",
      "unassigned_description": "Pour la planification d'événements physiques sans association d'animateurs.",
      "unassigned_example": "Ex. : conférences, séminaires publics, expositions.",
      "event_booking_alert_title": "Important",
      "event_booking_alert_message": "Ce type de calendrier présente des différences essentielles.",
      "event_booking_learn_more": "En savoir plus",
      "event_booking_tooltip_title": "Choses à savoir :",
      "event_booking_tooltip_content": "• Les calendriers d'événements n'ont pas d'utilisateurs, les réunions ne peuvent donc pas être attribuées à un utilisateur.\n• Comme aucun utilisateur n'est assigné, les outils de création de liens de réunion dynamiques ne sont pas pris en charge (Zoom, Google Meet, Microsoft Teams). Pour utiliser les réunions en ligne, copiez un lien de conférence statique depuis n'importe quel outil et collez-le dans l'emplacement de la réunion.\n• Comme aucun utilisateur n'est assigné, les réunions ne se synchronisent pas avec le calendrier d'un utilisateur depuis Paramètres du calendrier → Connexions. Les calendriers en conflit ajoutés à cet endroit ne sont pas pris en compte.\n• Les réunions se synchronisent uniquement avec le calendrier sélectionné dans la section Synchronisation externe de ce calendrier.\n• Les événements sont extraits et déplacés uniquement vers le calendrier externe sélectionné.\n• Un seul calendrier Google peut être connecté à l'aide de la synchronisation externe.",
      "class_booking": "Réservation de cours",
      "class_booking_description": "Un animateur rencontre plusieurs participants.",
      "class_booking_example": "Ex. : webinaires, formations de groupe, cours en ligne.",
      "collective_booking": "Réservation groupée",
      "collective_booking_description": "Plusieurs animateurs rencontrent un participant.",
      "collective_booking_example": "Ex. : entretiens avec panel, évaluations de comité.",
      "service_booking": "Réservation de service",
      "service_booking_description": "Planification sans faille pour les entreprises de services.",
      "service_booking_example": "Ex. : rendez-vous au spa, services de réparation, consultations.",
      "personal_booking": "Réservation personnelle",
      "personal_booking_description": "Planifie des réunions individuelles avec un membre d'équipe particulier.",
      "personal_booking_example": "Ex. : réunions avec les clients, consultations privées.",
      "personal": "Personnel",
      "explore_more_types": "Découvrez d'autres types",
      "no_calendars_added": "Aucun calendrier pour le moment. Configurez-en un !",
      "no_calendars_added_description": "Créez votre premier calendrier pour commencer à les programmer sans effort.",
      "no_groups_added": "Aucun groupe pour le moment. Commencez à organiser !",
      "no_calendars_yet": "Aucun calendrier pour le moment",
      "no_groups_yet": "Aucun groupe pour le moment",
      "no_calendars_access": "Aucun calendrier n'a encore été créé. Une fois un calendrier créé, il apparaîtra ici. Vous n'avez pas accès à un calendrier : veuillez Contact votre admin si nécessaire.",
      "no_groups_access": "Aucun groupe n'a encore été configuré. Une fois qu'un groupe est créé, il apparaîtra ici. Vous n'avez pas l'accès à un groupe : veuillez Contact votre admin si nécessaire.",
      "no_groups_added_description": "Utilisez le groupe pour conserver la structure de vos calendriers. Ajouter des calendriers à un groupe et partager une personne pour une réservation simple.",
      "group_success_message": "Le groupe est créé avec succès. Vous pouvez ajouter des calendriers à ce groupe.",
      "choose_calendars": "Choisissez des calendriers",
      "do_it_later": "Je le ferai plus tard",
      "add_calendars_to_group": "Ajoutez des calendriers au groupe",
      "select_calendars_to_add": "Veuillez sélectionner chaque calendrier que vous souhaitez transmettre au groupe {name}",
      "add_calendars": "Ajoutez un/des calendrier(s)",
      "continue": "continuer",
      "conflicting_calendars": "Calendriers en conflit",
      "conflicting_calendars_description": "Les calendriers épinglé sont déjà une partie d'un autre groupe. Voulez-vous les transmettre à votre nouveau groupe, <b>{name}</b>?",
      "group_associated_with": "Groupe en cours",
      "move_calendar_consent": "Je n'ai pas reçu de texte à traduire. Pourriez-vous s'il vous plaît fournir le texte que vous souhaitez faire traduire en français ?",
      "calendars_moved_successfully": "les calendriers sélectionnés ont été déplacés avec succès vers {name}.",
      "new_group": "Nouveau groupe",
      "back": "Retour",
      "share_otl": "Divisez votre ressource chaque Date avec un lien unique qui expire après une réservation, garantissant l'accès.",
      "copied_to_clipboard": "Copié dans le presse-papiers",
      "generate_link": "Générer un nouveau lien",
      "generate_link_error": "Impossible de générer un lien à usage unique. Veuillez réessayer",
      "share_schedule_link": " Le lien de réservation est déterminé via le slug. modifier le slug et le lien de réservation s'adaptera automatiquement à la modification.",
      "share_permanent_link": "Parfait pour les entonnoirs, la redirection du site web, ou les annonces, le lien permanent reste constant, non affecté via slug dynamique.",
      "copy": "copier",
      "share_embed_code": "Mettez ce code in votre HTML dans votre HTML où vous souhaitez que votre widget {embedType} apparaisse.",
      "scheduling_link": "Lien de planification",
      "permanent_link": "Lien permanent",
      "one_time_link": "Lien à usage unique",
      "embed_code": "Code d'intégration",
      "loading": "chargement…",
      "share_group": "Partager le groupe",
      "edit_group": "Modifier le groupe",
      "more_options": "Plus d'options",
      "share_calendar": "Partager le calendrier",
      "edit_calendar": "Modifier le calendrier",
      "troubleshoot_calendar_link": "Diagnostiquer le calendrier",
      "calendar_config_success": "Vous avez configuré avec succès votre calendrier personnel/groupe",
      "close": " Fermer",
      "added_calendars": "Calendrier(s) ajouté(s)",
      "select_calendars": "Sélectionnez un/des calendrier(s)",
      "settings_confirmation": "Pour ajouter, veuillez confirmer ces dynamiques.",
      "consent_checkbox_title": "Je comprends et j'accepte ces modifications.",
      "confirm": "Confirmer",
      "create_group_access_disabled": "Vous n'avez pas permission de créer un groupe. Contact votre admin pour obtenir l'accès.",
      "create_calendar_access_disabled": "Vous n'avez pas permission de créer un calendrier. Contact votre admin pour obtenir l'accès.",
      "create_room_access_disabled": "Vous n'avez pas l'autorisation de gérer les salles. Contactez votre admin pour obtenir l'accès.",
      "create_equipment_access_disabled": "Vous n'avez pas l'autorisation de gérer l'équipement. Contactez votre admin pour obtenir l'accès.",
      "preview_booking_widget": "Aperçu du widget de réservation",
      "share_service_menu": "Partager le menu de services",
      "back_message": "Retour à la liste des calendriers",
      "service_calendars": "Calendriers de service",
      "owned_by": "Propriétaire via",
      "owned_by_anyone": "personne",
      "owned_by_me": "Me",
      "all_groups": "Tous les groupes",
      "all_calendars": "Tous les calendriers",
      "not_grouped": "Non groupé",
      "delete_group_desc": "Voulez-vous vraiment supprimer ce groupe ? Cela supprimera également chaque membre des calendriers avec ce groupe.",
      "calendar_listing_title": "Liste de calendriers",
      "calendar_group_name": "Nom du calendrier/groupe",
      "success": "Réussite",
      "my_calendar": "mon calendrier",
      "service_calendar_description": "Planification sans faille pour les entreprises de services."
    },
    "preferences": {
      "preferences": "Préférences",
      "my_preferences": "Mes préférences",
      "account_preferences": "Préférence du compte",
      "user_preferences": "Préférences utilisateur",
      "set_preferences": "Définissez vos préférences pour votre compte.",
      "scheduling_options": "Options de planification",
      "meeting_location": "Lieu de la réunion",
      "zoom": "Zoom",
      "save_preferences": "Enregistrer les préférences",
      "in_app_preferences": "Préférences dans l'application",
      "set_start_day": "Définissez des préférences telles que le jour de démarrage de l'application",
      "view_options": "Afficher les options",
      "services": "Services",
      "feature_toggle_aria": "Bouton bascule de fonctionnalité",
      "week_starts_on": "La semaine commence le",
      "sunday": "dimanche",
      "widget_preferences": "Préférences du widget",
      "set_widget_language": "Définissez des préférences telles que la langue du widget",
      "language_and_region": "Langue et région",
      "language": "Langue",
      "english": "Anglais",
      "time_format": "Format d'heure",
      "time_format_value": "1:30 PM",
      "monday": "lundi",
      "custom_meeting_location": "Emplacement de réunion personnalisé",
      "view_appointments_in_1": "Affichez les rendez-vous dans",
      "timezone_uses_details_1": "Nous utiliserons ce fuseau horaire pour l’affichage des heures de rendez-vous dans l’application et dans vos e-mails liés aux rendez-vous — rien que pour vous. Cela n'affectera ni votre disponibilité ni le fonctionnement des réservations.",
      "business_timezones_1": "Fuseau horaire de l'entreprise",
      "business_timezones_tooltip_1": "Message : Choisir cette option garantit que vos préférences d'affichage sont alignées avec le fuseau horaire d'entreprise sélectionné. Si le fuseau horaire de l'entreprise change, votre fuseau horaire d'affichage s'ajustera automatiquement pour correspondre.",
      "recommended_timezones": "Fuseaux horaires recommandés",
      "all_timezones": "Tous les fuseaux horaires"
    },
    "availability": {
      "availability": "Disponibilité",
      "my_availability": "Ma disponibilité",
      "my_availability_and_booking_rules": "Disponibilités",
      "my_availability_and_booking_rules_description": "Définissez quand les réunions peuvent être réservées en fonction de la disponibilité du personnel.",
      "account_availability": "Disponibilité du compte",
      "timezone": "Fuseau horaire",
      "working_hours": "Heures de travail",
      "set_recurring_hours": "Définissez vos heures de travail récurrentes pour les réunions",
      "select_one": "Sélectionner un",
      "sunday": "Dimanche",
      "monday": "Lundi",
      "tuesday": "Mardi",
      "wednesday": "Mercredi",
      "thursday": "Jeudi",
      "friday": "Vendredi",
      "saturday": "Samedi",
      "widget_preferences": "Préférences du widget",
      "set_widget_language": "Définissez des préférences telles que la langue du widget",
      "language_and_region": "Langue et région",
      "language": "Langue",
      "english": "Anglais",
      "copy_to_all": "Copier à tous",
      "save_availability": "Sauvegarder la disponibilité",
      "add_time": "Ajouter une heure",
      "to": "À",
      "select_time": "Sélectionner l'heure",
      "add_user": "Ajouter un utilisateur",
      "accessRestricted": {
        "header": "Accès restreint",
        "message": "Vous ne faites pas partie de ce compte. Pour y accéder, ajoutez-vous à ce compte depuis Paramètres de l'agence > Teams > Modifier le membre de l'équipe, et attribuez le compte sous « Rôles et autorisations ».",
        "contact_admin": "Cette page est uniquement publique pour les administrateurs. Veuillez Contact votre admin pour obtenir de l'aide.",
        "button_text": "Accédez aux paramètres de l'agence."
      },
      "schedule": {
        "edit_schedule": "Modifier l'horaire",
        "schedule_name": "Nom du programme",
        "schedule_name_required": "Le nom du calendrier est obligatoire",
        "timezone": "Fuseau horaire",
        "timezone_placeholder": "Sélectionner un",
        "start_time": "Heure de début",
        "end_time": "Heure de fin",
        "add_availability_hour": "Ajouter une heure de disponibilité",
        "remove_availability_hour": "Supprimer l'heure de disponibilité",
        "unavailable": "Indisponible",
        "schedule_created": "Calendrier créé avec succès",
        "schedule_updated": "Calendrier mis à jour avec succès",
        "calendars_selected": "{count} calendrier",
        "calendars_selected_multiple": "{count} calendriers",
        "select_users_placeholder": "Rechercher des utilisateurs",
        "edit_default_schedule": "Modifier ce calendrier",
        "customize_event_type_schedule": "Personnaliser la planification pour ce calendrier uniquement",
        "multi_user_description": "Mise à jour de la disponibilité pour <b>{count} utilisateurs sélectionnés</b> - {calendar}",
        "bulk_edit_warning_banner": "Modification en masse activée. Les modifications écraseront les horaires existants pour tous les utilisateurs sélectionnés.",
        "bulk_edit_slot_applies_to_all": "Le créneau sélectionné s'appliquera à tous les utilisateurs sélectionnés.",
        "bulk_edit_slot_applies_to_selected": "Le créneau sélectionné s'appliquera aux {count} utilisateur(s) sélectionné(s).",
        "bulk_edit_applies_to_all": "Les modifications s'appliqueront aux {count} utilisateurs sélectionnés.",
        "bulk_edit_weekly_hours": "Modification en masse des horaires hebdomadaires",
        "bulk_edit_weekly_hours_title": "Modification en masse des horaires hebdomadaires",
        "bulk_edit_weekly_hours_desc": "Cela remplacera les horaires hebdomadaires pour tous les utilisateurs énumérés ci-dessous.",
        "edit_now": "Modifier maintenant",
        "bulk_edit": "Modifier en masse",
        "choose_days_weekly_hours": "Choisissez le(s) jour(s) pour définir les horaires hebdomadaires",
        "assign_to": "Assigner à :",
        "configure_weekly_hours": "Configurer les horaires hebdomadaires",
        "selected_users": "Utilisateurs sélectionnés :",
        "bulk_edit_select_users": "Sélectionner les utilisateurs à appliquer",
        "bulk_edit_select_users_placeholder": "Sélectionner les membres d'équipe…",
        "bulk_edit_select_at_least_one": "Veuillez sélectionner au moins un utilisateur.",
        "bulk_edit_editing_for": "Modification pour :",
        "bulk_edit_applies_to": "S'applique à :",
        "bulk_edit_user_count": "{count} utilisateur",
        "bulk_edit_users_count": "{count} utilisateurs",
        "show_less": "Afficher moins",
        "more": "Plus",
        "confirm_delete": "Confirmer la suppression",
        "confirm": "Confirmer",
        "delete_user_date_confirm": "Voulez-vous vraiment supprimer les horaires spécifiques à la date pour <b>{userName}</b> le <b>{date}</b> ?",
        "delete_date_confirm": "Voulez-vous vraiment supprimer les horaires spécifiques à la date pour tous les utilisateurs le <b>{date}</b> ?",
        "selected_calendar": "calendrier sélectionné",
        "edit_schedule_alert": "Les mises à jour effectuées ici s'appliqueront à",
        "schedule": "Planifier",
        "no_availability": "Aucune disponibilité",
        "date_specific_hours_show_more": "plus",
        "date_specific_hours_show_less": "moins",
        "date_specific_hours_recurring_meetings_enabled": "Il n'est pas possible d'ajouter des heures précises, car ce calendrier est lié à un calendrier pour lequel les réunions récurrentes sont activées. Pour continuer, veuillez désactiver les réunions récurrentes.",
        "recurring_incompatible_with_date_hours": "Les réunions récurrentes ne peuvent pas être activées car le calendrier de l'utilisateur comporte des heures précises, ce qui n'est pas compatible.",
        "incompatible_schedule_with_recurring": "{user} calendrier contient des heures spécifiques à une date, ce qui est incompatible avec les réunions récurrentes.",
        "incompatible_schedule_with_recurring_calendar": "Le calendrier contient des heures spécifiques à une date, ce qui est incompatible avec les réunions récurrentes.",
        "recurring_meetings_enabled_multi_user": "Les réunions récurrentes ne sont pas prises en charge pour les calendriers avec plusieurs membres d'équipe ou lorsqu'un membre d'équipe a des horaires spécifiques à une date ajoutées à son emploi du temps.",
        "weekdays": "En semaine, {timeRange}",
        "weekdays_hours_vary": "En semaine, les horaires varient",
        "weekend": "Week-end, {timeRange}",
        "weekend_hours_vary": "Le weekend, les heures varient",
        "days_hours_vary": "{days}, les heures varient",
        "date_specific_hours_tab_name": "Heures précises",
        "date_specific_hours": "{count} heures spécifiques à une date",
        "date_specific_hours_1": "1 heure spécifique à une date",
        "weekly_hours": "Heures hebdomadaires",
        "custom_schedule": "Horaire personnalisé",
        "select_schedule": "Sélectionnez un calendrier",
        "no_schedules_found": "Aucun horaire trouvé",
        "untitled": "Sans titre",
        "error_updating_schedules": "Erreur lors de la mise à jour des calendriers",
        "daily": "Quotidiennement",
        "weekly": "Hebdomadaire",
        "monthly": "Mensuel",
        "custom": "Personnalisé",
        "this_is_required": "Ceci est obligatoire",
        "search": "Rechercher",
        "edit_hours": "Modifier les heures",
        "schedule_name_duplicate": "Un calendrier portant ce nom existe déjà",
        "delete_schedule_title": "Supprimer le calendrier « {scheduleName} » ?",
        "delete_schedule_description": "Cette action est irréversible. Voulez-vous vraiment continuer ?",
        "delete_schedule_negative_text": "Annuler",
        "delete_schedule_positive_text": "Oui, supprimer.",
        "active_on": "Actif le",
        "weekly_working_hours": "Heures de travail hebdomadaires",
        "weekly_working_hours_subtext": "Sélectionner les jours et les horaires où vous travaillez",
        "copy_availability_hour": "Copier l'heure de disponibilité",
        "mins": "Minutes",
        "hours": "Heures",
        "save_weekly_hours": "Enregistrer les horaires hebdomadaires",
        "save_date_specific_hours": "Enregistrer les horaires spécifiques à une date",
        "update_weekly_hours_for_users": "Mettre à jour les heures hebdomadaires pour {count} utilisateurs",
        "set_date_specific_hours_for_users": "Définir des horaires spécifiques à une date pour {count} utilisateurs",
        "set_date_specific_hours_for_user": "Définir des heures spécifiques à une date"
      }
    },
    "connections": {
      "connections": "Connexions",
      "connect": "connecter",
      "conferencing": "Conférences",
      "my_connections": "Mes connexions",
      "account_connections": "Connexions de comptes",
      "connection_preferences": "Préférences de connexion",
      "manage_calendars_conferencing_channels": "Gérer les calendriers et les canaux de conférence",
      "main_integration_calendar": "Calendrier d'intégration principal",
      "event_integration_calendar": "Les événements créés sur un calendrier système dont vous faites partie seront également créés sur ce calendrier intégré",
      "2way_sync": "Synchronisation bidirectionnelle : Créez des événements système à partir d'événements inscrits sur le calendrier intégré principal",
      "calendars": "Calendriers",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Vérifier les conflits",
      "choose_accounts_to_connect": "Choisissez les comptes que vous souhaitez connecter",
      "payments": "Paiements",
      "stripe": "Stripe",
      "ads": "Annonces",
      "local_service_ads": "Annonces de services locaux",
      "fire_workflow": "Déclencher des flux de travail pour les événements réservés via la synchronisation bidirectionnelle",
      "connect_google_outlook": "Veuillez connecter votre compte Google/Outlook/iCloud pour pouvoir choisir le calendrier principal.",
      "execute_automation": "Exécuter l'automatisation",
      "save": "Enregistrer",
      "lsa": "Annonces de services locaux",
      "no_write_access": "Vous n'avez pas accès en écriture à ce calendrier",
      "connection_remove_confirmation": "Vous êtes sur le point de supprimer cette intégration",
      "active": "Actif",
      "icloud": {
        "title": "Intégration iCloud",
        "description": "Une authentification à deux facteurs et un mot de passe spécifique à l'application sont nécessaires pour connecter votre compte.",
        "email": "Adresse e-mail iCloud",
        "password": "Mot de passe iCloud",
        "connect": "Se connecter",
        "cancel": "Annuler"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Sélectionner un contact",
    "start_time": "Heure de début",
    "unassigned": "Non assigné",
    "end_time": "Heure de fin",
    "search_by_name_email_phone_or_company": "Rechercher par nom, e-mail, téléphone ou entreprise",
    "add_new": "Ajouter un nouveau",
    "pick_from_available_contacts": "Ou choisir parmi les contacts disponibles",
    "book_appointment": "Prendre rendez-vous",
    "add_blocked_off_time": "Ajouter un créneau d'indisponibilité",
    "recommended_timezones": "Fuseaux horaires recommandés",
    "all_timezones": "Tous les fuseaux horaires",
    "calendar": "Calendrier",
    "repeat": "Répétition",
    "date_and_time": "Date et heure",
    "close": "Fermer",
    "team_member": "Membre de l'équipe",
    "recurring_booking": "Réservations récurrentes",
    "one_slot_booking": "Réservation d'un créneau",
    "event_type": "Type d'événement",
    "occurrences_booked": "événements seront réservés",
    "repeats": "Répétitions",
    "booking_details": "Informations sur la réservation",
    "showing_slots_in_this_timezone": "Affichage des créneaux dans ce fuseau horaire :",
    "update_contact_tz": "Mettre également à jour le fuseau horaire du contact pour",
    "date": "Date",
    "slot": "Créneau",
    "calendar_default": "Calendrier par défaut",
    "custom": "Personnalisé",
    "meeting_notes": "(p. ex.) Notes de réunion pour notre prochain rendez-vous",
    "out_of_office": "(p. ex.) Absent du bureau pour la semaine !",
    "standard": "Par défaut",
    "appointment_title": "Titre du rendez-vous",
    "event_title": "Titre de l'événement",
    "appt_with_bob": "(p. ex.) Rendez-vous avec Bob",
    "vacation": "(p. ex.) Vacances",
    "show_notes": "Afficher les remarques",
    "hide_notes": "Masquer les remarques",
    "additional_preferences": "Préférences supplémentaires",
    "meeting_location": "Emplacement de la réunion",
    "appointment_status": "Statut du rendez-vous",
    "appt_description": "Description du rendez-vous",
    "recurring_details": "Informations récurrentes",
    "event_description": "Description de l'événement",
    "in_contact_timezone": "Dans le fuseau horaire du contact",
    "vacation_message": "Vous partez en vacances ? Vous prenez des congés ? Bloquez du temps dans votre agenda pour empêcher les clients de prendre rendez-vous ; les rendez-vous existants resteront dans votre calendrier.",
    "contact": "Contact",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "back": "Retour",
    "pick_available_contacts": "Ou choisir parmi les contacts disponibles",
    "no_contacts_found": "Aucun contact trouvé",
    "found": "trouvé",
    "select_one": "Choisissez-en un",
    "tz_tooltip": "Cela n'est important que si vous utilisez des valeurs personnalisées, telles que appointment_start_time appointment_end_time appointment_timezone, dans vos communications sortantes avec vos clients. Et il convertit simplement les informations susmentionnées en heure locale.",
    "meeting_location_tooltip": "Le lieu de la réunion sera défini tel que configuré dans le calendrier.",
    "appt_meeting_location_tooltip": "L'utilisateur peut définir le lieu de la réunion en fonction du rendez-vous.",
    "gmeet_tooltip": "Assurez-vous que le membre d'équipe concerné dispose d'un agenda Google défini comme calendrier principal.",
    "zoom_tooltip": "Assurez-vous que le membre d'équipe concerné dispose bien de Zoom.",
    "enter_meeting_location": "Saisissez le lieu de la réunion",
    "save_appointment": "Enregistrer le rendez-vous",
    "save_event": "Enregistrer l'événement",
    "search_contacts": "Rechercher par nom, e-mail, téléphone ou entreprise",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Fuseau horaire personnalisé",
    "system_timezone": "Fuseau horaire du système",
    "contact_timezone": "Fuseau horaire du contact",
    "account_timezone": "Fuseau horaire du compte",
    "an_error_occurred": "Une erreur s'est produite"
  },
  "popup": {
    "calendar": "Calendrier",
    "appointment_owner": "Propriétaire du rendez-vous",
    "source": "Source",
    "booked_by": "Réservé par",
    "view_activity_log": "Consulter le journal d'activité",
    "status": "Statut",
    "cancel_appointment": "Annuler le rendez-vous",
    "cancel_all": "Annuler tout",
    "google_event": "Événement Google",
    "outlook_event": "Événement Outlook",
    "blocked_slot": "Créneau bloqué",
    "appointment": "Rendez-vous",
    "confirmed": "Confirmé",
    "unconfirmed": "Non confirmé",
    "cancelled": "Annulé",
    "showed": "Honoré",
    "no_show": "Non honoré",
    "invalid": "Non valide",
    "more": "Plus",
    "less": "Moins",
    "edit": "Modifier",
    "reschedule_all": "Tout reporter",
    "guests": "Invité(s)",
    "guest_count": "Nombre d'invité(s)"
  },
  "create_calendar": {
    "calendar_name": "Nom du calendrier",
    "calendar_logo": "Logo du calendrier",
    "select_team_member": "Sélectionner les membres d'équipe",
    "select_single_team_member": "Sélectionnez un membre d'équipe",
    "eg_outbound_reach": "(p. ex.) Couverture sortante",
    "description": "Description",
    "amount": "Montant",
    "description_placeholder": "Rédiger une description",
    "meeting_duration": "Durée de la réunion",
    "meeting_location": "Lieu de la réunion",
    "seats_per_class": "Places par cours",
    "group": "Groupe",
    "custom_url": "URL personnalisée",
    "meeting_invite_title": "Titre de l'invitation à la réunion",
    "event_color": "Couleur de l'événement",
    "availability_type": "Type de disponibilité",
    "new_calendar": "Nouveau calendrier",
    "add_description": "Ajouter une description",
    "remove_description": "Supprimer la description",
    "booking_availability": "Disponibilité pour les réservations",
    "slug_tooltip": "Personnalisez l'URL du widget de réservation.",
    "meeting_location_tooltip": "Les liens de réunion sont affichés dans les événements du calendrier en tant que « lieu de réunion » et vous permettent d'ajouter des éléments tels que des liens Zoom.",
    "advanced_settings": "Paramètres avancés",
    "show_more_schedule": "Afficher plus",
    "show_more_helper_text": "Pour personnaliser davantage vos heures d'ouverture, veuillez vous rendre dans les paramètres avancés.",
    "reschedule_preference": "Préférence de report",
    "reschedule_preference_subtext": "Si un {contactLabel} reprogramme un rendez-vous :",
    "reassign_through_round_robin": "Réassigner via Round-robin",
    "keep_same_assinged_user": "Conserver le même propriétaire du rendez-vous",
    "new_appointment_preference": "Préférence des nouveaux rendez-vous",
    "new_appointment_preference_text": "Toujours réserver avec l'utilisateur assigné au {contactLabel}.",
    "new_appointment_preference_subtext": "Prenez de nouveaux rendez-vous avec l'utilisateur assigné au {contactLabel} au lieu d'utiliser la planification Round-robin.",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "service_calendar_name": "Nom du service",
    "service_logo": "Logo du service",
    "service_select_team_member": "Sélectionnez un membre du personnel",
    "service_duration": "Durée du service",
    "appointment_invite_title": "Titre de l'invitation au rendez-vous",
    "payment_placeholder": "Saisissez une description qui sera affichée à l'utilisateur pour l'informer du paiement.",
    "deposit_amount": "Montant de l'acompte",
    "collect_deposit_amount": "Accepter les paiements partiels",
    "percentage": "Pourcentage",
    "total_amount": "Montant total",
    "enter_meeting_location": "Saisissez le lieu de la réunion",
    "accept_payments": "Accepter les paiements",
    "aria": {
      "should_accept_payment": "Devrait accepter le paiement"
    },
    "calendar_name_tooltip": "Nom du calendrier à afficher sur le widget de réservation.",
    "booking_availability_tooltip": "Définissez les jours et les heures pendant lesquels les réservations peuvent être faites. Il s'agit des heures d'ouverture hebdomadaires par défaut qui sont indiquées aux utilisateurs lorsqu'ils sélectionnent une plage horaire.",
    "select_team_member_tooltip": "Sélectionnez le ou les membres de l'équipe qui prendront part à cette réunion.",
    "seats_per_class_tooltip": "Définissez le nombre maximum de participants autorisés à réserver ce cours. Une fois toutes les places réservées, ce créneau horaire ne sera plus disponible à la réservation.",
    "meeting_color": "couleur de couleur",
    "meeting_duration_tooltip": "Cela définit la durée de votre réunion."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Conseil pratique",
      "timezone_change_tip": "Les fuseaux horaires peuvent être modifiés à tout moment dans les préférences de fuseau horaire",
      "save": "Enregistrer les modifications",
      "close": "Fermer",
      "meeting_details": "Détails de base",
      "availability": "Disponibilité",
      "forms_and_payment": "Formulaires et paiement",
      "notifications_and_additional_options": "Notifications et options supplémentaires",
      "connections": "Connexions",
      "customizations": "Personnalisations",
      "create": "Créer",
      "edit": "Modifier",
      "equipments": "Salles et équipements",
      "service_details": "Informations sur le service",
      "booking_rules": "Règles de réservation",
      "advanced_settings": "Paramètres avancés",
      "form_and_confirmation": "Formulaire et confirmation",
      "payments": "Paiements",
      "notifications_and_policies": "Notifications et politiques",
      "widget_appearance": "Apparence du widget",
      "saving_changes": "Il minute suffit d'enregistrer le dernier enregistrement dynamique",
      "calendar_id": "ID de calendrier",
      "saveCalendarSuccess": "Calendrier enregistré avec succès",
      "external_sync": "Synchronisation externe",
      "external_sync_and_channel": "Synchronisation externe & canaux",
      "booking_channels": "Canaux de réservation",
      "meeting_location": "Emplacement de la réunion",
      "staff_location": "Personnel et emplacement"
    },
    "meeting_details": {
      "meeting_location": "Lieu de la réunion",
      "meeting_location_label": "Emplacement de la réunion",
      "enter_meeting_location": "Saisissez le lieu de la réunion",
      "click_to_upload": "Cliquez pour importer",
      "square": "Carré",
      "circle": "Cercle",
      "remove_logo": "Supprimer le logo",
      "meeting_invite_title_tooltip": "Il s'agit du titre de la réunion du calendrier qui s'affiche dans la vue de la liste des rendez-vous, dans la vue du calendrier et dans les calendriers de tiers.",
      "event_color_tooltip": "Choisissez une couleur pour cet événement de réservation. Les couleurs sont synchronisées avec les événements dans Google Agenda.",
      "enter_a_name": "Veuillez saisir un nom.",
      "enter_an_event_title": "Veuillez saisir le titre de l'événement.",
      "high_priority": "Priorité élevée",
      "medium_priority": "Priorité moyenne",
      "low_priority": "Priorité basse",
      "priority": "priorité",
      "custom": "Personnalisée",
      "zoom_not_added": "L'utilisateur n'a pas encore connecté son compte Zoom.",
      "opt_avail": "Optimiser la disponibilité",
      "opt_equal": "Optimiser la répartition",
      "team_members": "Sélectionner les membres d'équipe",
      "team_members_location": "Sélectionner le personnel et attribuer l'emplacement de réunion",
      "team_member": "Sélectionner un membre de l'équipe",
      "team_member_location": "Sélectionner le personnel et attribuer l'emplacement de réunion",
      "meeting_location_required": "Le lieu de la réunion est obligatoire.",
      "meeting_details": "Détails de base",
      "meeting_details_description": "Informations de base servant à identifier ce calendrier.",
      "or_drag_and_drop": "ou par glisser-déposer",
      "service_details": "Informations sur le service",
      "team_member_disabled_recurring_tooltip": "Un seul membre d'équipe est autorisé à participer aux réunions récurrentes. Pour ajouter plusieurs membres d'équipe, veuillez désactiver les réunions récurrentes.",
      "team_member_disabled_class_booking_tooltip": "Un seul membre d'équipe peut être ajouté à un calendrier de réservation de cours.",
      "advanced_settings": "Paramètres avancés",
      "enable_contact_assigned_to_setting": "Pour activer ce paramètre, le formulaire doit être le premier dans l'ordre des widgets. Veuillez réorganiser l'ordre des widgets à partir de l'onglet Formulaires et paiement.",
      "reschedule_preference_setting_tooltip": "Choisissez à qui le rendez-vous doit être attribué lorsqu'un {contactLabel} le reporte à partir du widget de réservation.",
      "appointment_preference_tooltip": "Choisissez si les nouveaux rendez-vous doivent toujours être pris avec l'utilisateur assigné au {contactLabel}. Si un utilisateur est assigné à un {contactLabel}, c'est lui qui sera privilégié ; sinon, l'assignation se fera selon la méthode Round-robin. Conseil : Désactivez l'option « Autoriser la sélection du personnel » pour empêcher les personnes effectuant la réservation de modifier le membre du personnel sur le widget de réservation.",
      "add_location": "Ajouter un emplacement",
      "multiple_locations_neo": "Proposez plusieurs options d'emplacement à la personne effectuant la réservation. Seul le widget Neo prend en charge plusieurs emplacements.",
      "make_owner": "Rendre propriétaire",
      "only_one_team_member": "Un seul membre d'équipe est autorisé en cas d'ajout de plusieurs lieux.",
      "ask_the_booker_error_message": "Le lieu Demander à l'auteur de la réservation existe déjà.",
      "enter_location": "Saisir la valeur d'emplacement",
      "enter_display_label": "Saisir l'étiquette d'affichage",
      "add_display_label": "Ajouter une étiquette d'affichage",
      "multiple_location_support_message": "Proposez plusieurs options d'emplacement à la personne effectuant la réservation. Seul le widget Neo prend en charge plusieurs emplacements.",
      "only_one_team_member_personal_calendar": "Un seul membre d'équipe est autorisé à effectuer une réservation personnelle. ",
      "ms_teams_not_added": "L'utilisateur n'a pas encore connecté son compte Microsoft Teams.",
      "enable_new_appt_preference": "Activez la nouvelle préférence de rendez-vous",
      "enable_new_appt_preference_desc": "En activant l'option « <b>Toujours réserver avec l'utilisateur assigné au {contactLabel}</b> », le <b>formulaire</b> sera automatiquement défini comme première étape dans l'ordre des widgets.",
      "location_exists_toast": "Emplacement de la conférence déjà ajouté",
      "not_supported_with_multiple_team_members": "Non pris en charge avec plusieurs membres de l'équipe",
      "not_supported_personal_calendar": "Non pris en charge dans le calendrier personnel",
      "not_supported_class_booking": "Non pris en charge dans le calendrier de réservation de cours",
      "not_supported_collective_booking": "Non pris en charge dans le calendrier collectif",
      "not_supported_service_booking": "Non pris en charge dans le calendrier de service",
      "not_supported_round_robin": "Non pris en charge dans le calendrier round robin",
      "not_supported_event": "Non pris en charge dans le calendrier des événements",
      "calendar_logo_tooltip": "Choisissez un logo à afficher sur le widget de réservation.",
      "calendar_name_tooltip": "Nom du calendrier à afficher sur le widget de réservation.",
      "description_tooltip": "Décrivez le contenu du calendrier, à afficher sur le widget de réservation.",
      "group_tooltip": "Vous pouvez attribuer ce calendrier à un groupe (s'il est créé). Les utilisateurs accédant au lien du groupe peuvent parcourir et réserver sur tous les calendriers de ce groupe.",
      "custom_url_tooltip": "Personnalisez l'URL du widget de réservation.",
      "meeting_color_tooltip": "Choisissez une couleur pour cet événement de réservation.",
      "add_display_label_tooltip": "Masquez l'emplacement réel et affichez une étiquette personnalisée jusqu'à ce que la réunion soit réservée (s'applique lorsque plusieurs emplacements sont ajoutés).",
      "meeting_location_tooltip": "Sélectionnez un emplacement ou choisissez l'option Personnalisé pour ajouter une adresse ou un lien de réunion.",
      "team_members_location_tooltip": "Sélectionnez le membre du personnel qui participera à cette réunion et définissez l'emplacement de la réunion.",
      "meeting_distribution": "Répartition des réunions",
      "meeting_distribution_tooltip": "Choisissez comment les réunions sont attribuées au personnel.",
      "opt_avail_tooltip": "Attribuez des réunions au membre du personnel qui est disponible à l'heure choisie, sans tenir compte des réservations précédentes. Optimise l'utilisation des créneaux disponibles et améliore les taux de réussite des réservations.",
      "opt_equal_tooltip": "Répartissez équitablement les réunions entre tous les membres du personnel en tenant compte des réservations précédentes. Priorise l'équité plutôt que la disponibilité.",
      "priority_tooltip": "Définissez le niveau de préférence pour l'attribution des réunions lorsque plusieurs employés sont disponibles. Le personnel prioritaire sera envisagé en premier pour les réservations, suivi du personnel à priorité moyenne et faible.",
      "contact_routing_preference": "Préférence de routage des contacts",
      "contact_routing_preference_tooltip": "Définissez comment les {contactsLabel} nouveaux et existants sont attribués aux membres du personnel, soit selon la méthode Round-robin, soit selon leur propriétaire d'origine.",
      "team_members_location_owner_tooltip": "L'utilisateur principal qui est responsable de la réunion et détermine l'emplacement final de la réunion.",
      "owner": "propriétaire",
      "upload_from_system": "Télécharger depuis le système",
      "choose_from_media_storage": "Choisir dans le stockage multimédia",
      "only_one_team_member_allowed": "Seul un membre de l'équipe est autorisé.",
      "at_least_two_team_members_required": "Au moins 2 membres de l'équipe sont requis.",
      "at_least_one_team_member_required": "Au moins un membre de l'équipe est requis.",
      "widget_shape": "Forme du widget :",
      "widget_bookings_path": "/widget/réservations/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "photo de profil",
      "meeting_location_placeholder": "Emplacement de la réunion",
      "team_member_meeting_location": "Personnel et emplacement de la réunion",
      "meeting_location_desc": "Attribuez du personnel à ce calendrier et définissez où se déroulent les réunions.",
      "event_calendar_meeting_location_desc": "Choisissez où se tiendra la réunion."
    },
    "meeting_location": {
      "ask_the_booker": "Demandez au Booker (le Booker indique l'emplacement)",
      "ask_the_booker_desc": "Le client est invité à saisir un emplacement de réunion de son choix lors de la réservation",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Téléphone",
      "full_address": "Adresse complète",
      "custom": "Personnalisé",
      "meeting_location": "Emplacement de la réunion"
    },
    "availability": {
      "my_availability": "Ma disponibilité",
      "calendar_availability": "Disponibilité du calendrier",
      "calendar_availability_desc": "Définissez quand les réunions peuvent être réservées sur ce calendrier.",
      "set_availability": "Définissez votre disponibilité pour le calendrier ici.",
      "standard": "Standard",
      "custom": "Personnalisée",
      "to": "À",
      "copy_to_all": "Copier à tous",
      "add_time": "Ajouter une heure",
      "recurring_meeting": "Réunion récurrente",
      "recurring_info": "Un seul utilisateur par calendrier pour les réservations récurrentes.",
      "repeat": "Répétition",
      "times_to_repeat": "Nombre de répétitions",
      "slots_unavailable": "Si les créneaux ne sont pas disponibles ?",
      "overlap_status": "Statut des rendez-vous pour les créneaux qui se chevauchent ",
      "meeting_interval": "Intervalle entre les réunions",
      "meeting_duration": "Durée de la réunion",
      "minimum_scheduling": "Préavis de planification minimum",
      "date_range": "Période",
      "count_available_days_only": "Compter uniquement les jours disponibles",
      "count_available_days_only_tooltip": "Ignore les jours sans disponibilité configurée. Par exemple, si vous êtes fermés le week-end, une plage de 2 jours le vendredi s'étendra pour inclure le lundi et le mardi.",
      "maximum_bookings_per_day": "Nombre maximum de réservations par jour",
      "maximum_bookings_per_slot": "Nombre maximum de réservations par créneau",
      "maximum_bookings_per_slot_per_user": "Nombre maximum de réservations par créneau (par utilisateur)",
      "seats_per_class": "Places par cours",
      "pre_buffer_time": "Tampon préalable",
      "post_buffer_time": "Tampon final",
      "pre_buffer_tooltip": "Le tampon préalable est un temps supplémentaire qui peut être ajouté avant un rendez-vous, ce qui permet de disposer de plus de temps pour se préparer.",
      "post_buffer_tooltip": "Le tampon final est un temps supplémentaire qui peut être ajouté après un rendez-vous, ce qui permet de disposer de plus de temps pour conclure.",
      "buffer_time": "Tampon",
      "daily": "Quotidiennement",
      "weekly": "Hebdomadaire",
      "monthly": "Mensuellement",
      "skip_booking": "Ignorer la réservation des créneaux non disponibles",
      "continue_booking": "Continuer la réservation",
      "book_next_available": "Réserver le prochain créneau disponible",
      "confirmed": "Confirmé",
      "unconfirmed": "Non confirmé",
      "enter_valid_hours": "Veuillez saisir des heures d'ouverture valides",
      "enter_valid_avail": "Veuillez saisir une disponibilité personnalisée valide",
      "availability_type_tooltip": "Choisissez la disponibilité standard pour les réservations normales proposées chaque semaine. Choisissez Personnalisée pour les réservations uniquement disponibles à des dates spécifiques.",
      "meeting_interval_tooltip": "Contrôle la fréquence d'affichage des créneaux de réservation.\nPour une réunion de 30 minutes : \n• Choisissez 1 heure pour afficher les créneaux en début de chaque heure. \n• Choisissez 30 minutes pour afficher les créneaux toutes les 30 minutes.",
      "date_range_tooltip": "Les événements peuvent être programmés au cours des n jours à venir.",
      "maximum_bookings_per_day_tooltip": "Nombre maximal de réunions autorisées par jour sur ce calendrier.",
      "maximum_bookings_per_slot_tooltip": "Limitez le nombre de réunions qu'un utilisateur peut recevoir sur le même créneau horaire. Si la limite est atteinte, la réservation est attribuée à l'utilisateur suivant dans la file d'attente Round Robin ou le créneau devient indisponible.",
      "add_days": "Ajouter des jours",
      "month_on_day": "Mensuellement le jour",
      "month_on_last_day": "Mensuellement le dernier jour",
      "day": "Jour",
      "week": "Semaine",
      "month": "Mois",
      "mins": "Minutes",
      "hours": "Heures",
      "days": "Jours",
      "weeks": "Semaines",
      "months": "Mois",
      "meeting_interval_error": "L'intervalle entre les réunions doit être compris entre 5 minutes et 12 heures.",
      "meeting_duration_error": "La durée de la réunion doit être comprise entre 1 min et 12 heures.",
      "buffer_time_error": "Le tampon doit être inférieur à 12 heures",
      "appointment_interval": "Intervalle entre les rendez-vous",
      "appointment_duration": "Durée du rendez-vous",
      "maximum_appointments_per_day": "Nombre maximum de rendez-vous par jour",
      "subTitle": "Choisissez la date à laquelle vous souhaitez définir des heures précises.",
      "heading_1": "Heures hebdomadaires disponibles",
      "scheduling_availability_heading": "Disponibilité pour les réservations",
      "scheduling_availability_tooltip": "Utilisez un horaire de disponibilité existant ou créez-en un sur mesure pour ce calendrier.",
      "tooltip_1": "Établissez votre disponibilité hebdomadaire. Il s'agit de vos heures standard qui seront appliquées chaque semaine.",
      "heading_2": "Quand êtes-vous disponible ?",
      "unavailable_label": "Non disponible",
      "tooltip_2": "Adaptez votre emploi du temps à des dates précises. Remplacez vos heures hebdomadaires normales en indiquant votre disponibilité ou votre indisponibilité pour les dates sélectionnées.",
      "date_specific_level": "Ajouter des heures précises",
      "specific_hours_button": "Heures précises",
      "specific_hours_description": "Définissez des disponibilités personnalisées pour des dates spécifiques qui diffèrent de vos horaires hebdomadaires.",
      "overlap_error": "Les créneaux ne peuvent pas se chevaucher",
      "apply": "Appliquer",
      "copy_times_to": "Copier les heures vers",
      "no_date_specific_heading": "Aucune heure précise ajoutée.",
      "no_date_specific_description": "Vous pouvez ajouter une date et une heure précises à votre disponibilité ou les supprimer.",
      "recurring_disabled_conditions_tooltip": "sont des réunions récurrentes. Pour les résoudre, assurez-vous que le calendrier comporte un seul membre de groupe et qu'il n'a pas été ajouté à une date précise.",
      "date_specific_hours_disabled_conditions_tooltip": "Pour ajouter une heure précise, assurez-vous que les réunions récurrentes sont désactivées.",
      "recurring_disable_event_calendar_conditions": "sont des réunions récurrentes. Pour les fournir, assurez-vous qu'aucune heure précise n'a été ajoutée.",
      "service_duration": "Durée du service",
      "service_interval": "Intervalle entre les services",
      "service_interval_tooltip": "L'intervalle entre les réunions définit la fréquence à laquelle les créneaux de réservation apparaissent dans le calendrier. Par exemple, pour un événement de 30 minutes, un intervalle de 1 heure signifie que les créneaux apparaissent toutes les heures. Un intervalle de 30 minutes signifie que les créneaux apparaissent toutes les 30 minutes.",
      "service_duration_tooltip": "Cela définit la durée de votre rendez-vous.",
      "minimum_scheduling_tooltip": "Cela définit le temps minimum requis pour réserver un rendez-vous via le widget de calendrier. Par exemple, si le paramètre est fixé à 4 heures, les réservations doivent être effectuées au moins 4 heures avant le début du rendez-vous.",
      "look_busy_title": "Avoir l'air occupé(e)",
      "look_busy_helper_text": "Masquez un pourcentage de vos créneaux disponibles sur le widget de réservation afin d'apparaître plus occupé(e) et plus demandé(e).",
      "look_busy_percentage_description": "Masquer le nombre de créneaux disponibles de x %.",
      "maximum_bookings_per_slot_tooltip_personal": "Nombre maximum de réunions autorisées dans un seul créneau horaire.",
      "enable_recurring_title": "Activer la réunion récurrente",
      "enable_recurring_desc": "L'activation des <b>réunions récurrentes</b> désactivera automatiquement les paramètres suivants, car ils ne peuvent pas coexister :",
      "date_specific_hours": "Toutes les <b>heures précises</b> seront supprimées.",
      "multiple_team_members": "<b>Il n'est plus possible d'avoir plusieurs membres d'équipe</b> : un seul membre peut rester dans cet agenda.",
      "partial_payments": "<b>Les paiements incomplet</b> seront supprimés, et le montant total sera collecté.",
      "select_team_member_to_keep": "Sélectionnez un groupe pour conserver in ce calendrier :",
      "select_team_member": "Sélectionner un membre de l'équipe",
      "partial_payments_disabled": "Puisque les paiements partiels seront désactivés, comment souhaitez-vous percevoir le montant total pour les rendez-vous récurrents ?",
      "enable_date_specific_hours": "Activer les heures précises",
      "enable_date_specific_hours_desc": "L'activation des <b>heures précises</b> désactivera automatiquement le paramètre suivant, car ils ne peuvent pas coexister :",
      "recurring_meetings_disabled": "<b>Les réunions récurrentes seront désactivées</b>, les {contactsLabel} pourront prendre uniquement des rendez-vous individuels en fonction des dates disponibles que vous aurez définies.",
      "payment_preference": "Préférence de paiement :",
      "team_members_in_this_calendar": "Membres de l'équipe dans cet agenda",
      "other_team_members": "Autres membres de l'équipe (non ajoutés à cet agenda)",
      "select_team_member_tooltip": "Sélectionnez le ou les membres de l'équipe qui prendront part à cette réunion.",
      "meeting_duration_tooltip": "Cela définit la durée de votre réunion.",
      "add_another_duration": "Ajouter une autre durée",
      "set_as_default": "Définir par défaut",
      "default_duration": "Par défaut",
      "max_duration_options_reached": "Vous pouvez sélectionner 3 options de durée au maximum",
      "duplicate_duration_error": "Les valeurs de durée doivent être uniques",
      "empty_duration_error": "La durée de la réunion est obligatoire.",
      "multi_duration_tooltip": "Proposez plusieurs options de durée (par exemple : 15, 30 ou 60 minutes). Les clients peuvent choisir la durée de leur choix lors de la réservation.",
      "date_specific_hours_tooltip": "Adaptez votre emploi du temps à des dates précises. Remplacez vos heures hebdomadaires normales en indiquant votre disponibilité ou votre indisponibilité pour les dates sélectionnées.",
      "recurring_meeting_tooltip": "Permettre aux réunions de se répéter plusieurs fois au cours d'une période donnée.",
      "repeat_frequency_tooltip": "Sélectionnez la fréquence de cet événement récurrent.",
      "time_to_repeat_tooltip": "Définissez le nombre total de récurrences.",
      "slots_unavailable_tooltip": "Choisissez ce qu'il faut faire si un ou plusieurs créneaux horaires dans une réservation récurrente sont déjà réservés.",
      "skip_booking_tooltip": "Seuls les créneaux disponibles seront réservés. Toutes les dates indisponibles dans la série récurrente seront sautées.",
      "force_book": "Livre de force",
      "force_booking_tooltip": "Tous les créneaux seront réservés, même s'il y a un conflit. Utilisez cette option avec prudence pour éviter les doubles réservations.",
      "book_next_available_tooltip": "Si un créneau sélectionné est indisponible, réservez le prochain créneau disponible sur le même horaire récurrent (par exemple, le lundi suivant si c'est hebdomadaire).",
      "slot_interval_tooltip": "Définissez l'intervalle entre les heures de début des créneaux disponibles consécutifs. Par exemple, si la durée de votre réunion est de 30 minutes et que vous définissez l'intervalle à 60 minutes, un utilisateur peut réserver à 9 h, puis à 10 h, et ainsi de suite, même si chaque réunion ne dure que 30 minutes.",
      "minimum_scheduling_notice_tooltip": "Exigez que les utilisateurs réservent les réunions au moins autant de temps à l'avance.",
      "date_range_preferences_tooltip": "Définissez jusqu'à quelle date future les réservations peuvent être effectuées à partir d'aujourd'hui.",
      "maximum_bookings_per_slot_preferences_tooltip": "Limitez le nombre de réunions qui peuvent être programmées pour le même créneau horaire.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Limitez le nombre de réunions qui peuvent être programmées pour le même créneau horaire (par utilisateur).",
      "pre_buffer_time_tooltip": "Temps à bloquer avant chaque réunion, afin de disposer de temps supplémentaire de préparation.",
      "post_buffer_time_tooltip": "Temps à bloquer après chaque réunion, afin de disposer de temps supplémentaire de préparation.",
      "seats_per_class_tooltip": "Définissez le nombre maximum de participants autorisés à réserver ce cours. Une fois toutes les places réservées, ce créneau horaire ne sera plus disponible à la réservation.",
      "maximum_bookings_per_slot_per_user_tooltip": "Limitez le nombre de réunions qui peuvent être programmées pour le même créneau horaire (par utilisateur).",
      "repeat_frequency": "Fréquence de répétition",
      "slot_interval": "Intervalle de créneau",
      "skip_booking_helper_text": "Seuls les créneaux disponibles seront réservés. Toutes les dates indisponibles dans la série récurrente seront sautées.",
      "force_book_helper_text": "Tous les créneaux seront réservés, même s'il y a un conflit. Utilisez cette option avec prudence pour éviter les doubles réservations.",
      "book_next_available_helper_text": "si un total est indisponible, redirection des rendez-vous disponibles.",
      "bulk_edit": "Modifier en masse",
      "select_users": "Sélectionner des utilisateurs",
      "select_all": "Sélectionner tout",
      "times_to_repeat_tooltip": "Définissez le nombre total de récurrences.",
      "custom_recurrence": "Récurrence personnalisée",
      "repeats_every": "Se répète chaque",
      "availability_schedule": "Disponibilités",
      "availability_schedule_desc": "Définissez quand les réunions peuvent être réservées en fonction de la disponibilité du personnel.",
      "no_users_added": "Aucun membre du personnel ajouté.",
      "no_users_added_description": "Veuillez ajouter un membre du personnel pour vérifier sa disponibilité",
      "add_users": "Ajouter du personnel",
      "minimum_scheduling_notice_error": "Veuillez saisir une valeur inférieure ou égale à 1 440 min.",
      "please_select_date": "Veuillez sélectionner une date pour continuer"
    },
    "forms_payment": {
      "forms": "Formulaires et invités",
      "forms_sub": "Configurez les préférences pour la dernière page qui s’affiche après une réservation réussie.",
      "select_form": "Sélectionner un formulaire",
      "enable_same_user_assignment": "Assigner les contacts aux membres d'équipe chargés du calendrier concerné à chaque fois qu'un rendez-vous est pris.",
      "sticky_contacts_label": "{contactsLabel} épinglé",
      "sticky_contacts": "Pré-remplir les champs",
      "confirmation_page": "Page de confirmation",
      "default": "Par défaut",
      "thank_you_message": "Message de remerciement",
      "redirect_url": "URL de redirection",
      "use_custom_form_rules": "Utilisez les paramètres du formulaire",
      "custom_form_confirmation_alert": "Ce calendrier utilise un formulaire personnalisé. Toutes les règles conditionnelles configurées pour afficher ou masquer des champs, ou disqualifier des prospects, seront toujours exécutées avant la réservation.",
      "default_message_tooltip": "Affiche le message de confirmation configuré après la réservation du rendez-vous.",
      "redirect_url_tooltip": "Redirige le client vers la page configurée une fois le rendez-vous pris.",
      "use_custom_form_rules_tooltip": "Utilise la redirection ou le message personnalisé défini dans le formulaire personnalisé. Si aucune règle ne s'applique, le message de confirmation du calendrier sera affiché.",
      "thank_you": "Message de remerciement",
      "enter_url": "Saisissez une URL",
      "enter_thank_you_message": "Saisir un message de remerciement.",
      "amount_tab_hidden_label": "Emplacement de l'onglet Montant",
      "percentage_tab_hidden_label": "Espace réservé de l'onglet Pourcentage",
      "pixel_id": "Meta Id de pixel (facultatif)",
      "auto_confirm": "Confirmer automatiquement les nouvelles réunions du calendrier",
      "configure_payment": "Configurer les options de paiement",
      "accept_payments": "Accepter les paiements",
      "test": "Test",
      "live": "En direct",
      "enable_guests": "Ajouter des invités",
      "add_guest_tooltip": "Ajouter un invité permettra au participant d'ajouter plusieurs participants au même rendez-vous.",
      "add_guest_custom_form_tooltip": "Si vous activez cette option, les invités recevront un e-mail généré par le système avec un lien vers le formulaire personnalisé une fois leur rendez-vous confirmé. Pour éviter les e-mails en double, assurez-vous qu'aucun e-mail de confirmation distinct n'est déjà configuré pour les invités. (Vérifiez cela dans l'onglet Notifications > Notification de confirmation).",
      "add_guest_same_form_check": "Envoyer le même formulaire de collecte d'informations par courrier à tous les invités.",
      "payment_tooltip": "Le paiement sera pris en compte seulement pour le participant principal et non pour les invités.",
      "default_form": "Par défaut (prénom, nom, e-mail, téléphone, notes)",
      "select_form_tooltip": "Si vous souhaitez collecter plus d'informations que le prénom, le nom, l'e-mail et le numéro de téléphone auprès des personnes qui effectuent une réservation sur ce calendrier, créez un formulaire personnalisé dans Sites > Formulaires > Générateur, puis sélectionnez le formulaire dans la liste déroulante.",
      "confirmation_page_tooltip": "Lorsque quelqu'un effectue une réservation, vous pouvez choisir de lui afficher un message personnalisé sur la même page (par défaut) ou de le rediriger vers une page de votre choix (redirection).",
      "add_guest_collect_email": "Nom et e-mail",
      "add_guest_collect_detail": "Collecter les informations des invités",
      "add_guest_count_only": "Nombre seulement",
      "guest_collection_mode_label": "Informations sur les invités à recueillir",
      "guest_collection_mode_email": "Nom et e-mail",
      "guest_collection_mode_phone": "Nom et téléphone",
      "guest_collection_mode_email_phone": "Nom, e-mail et téléphone",
      "custom_email_notification": "Envoyer un formulaire personnalisé aux invités.",
      "consent_label": "Case de consentement",
      "consent_input_placeholder": "Ajouter un texte de consentement",
      "same_user_assignment_tooltip": "Pour activer ce paramètre, le formulaire doit apparaître en premier sur le widget. Réorganisez le widget pour positionner le formulaire en premier afin d'activer ce paramètre.",
      "consent_tooltip": "Demandez aux contacts de donner leur consentement lors de la prise de rendez-vous.",
      "stripe_error": "Jusqu'à deux décimales (exemple : 25,99)",
      "auto_confirm_service": "Confirmer automatiquement les nouveaux rendez-vous",
      "service_form_message": "Si un contact réserve plusieurs services, il verra uniquement le formulaire par défaut dans le menu de services.",
      "deposit_amount_error": "Le montant de l'acompte doit être inférieur au montant total.",
      "deposit_percentage_error": "Le pourcentage d'acompte doit être inférieur à 100 %.",
      "partial_payment_tooltip": "Activez les paiements partiels pour collecter le montant de l'acompte auprès des clients pendant le processus de prise de rendez-vous.",
      "partial_payment_enable_error": "Le montant total saisi doit être supérieur à 0 pour permettre les paiements partiels.",
      "payment_disable_text_integration": "Intégrez un fournisseur de services de paiement sous Paiements > Intégrations pour commencer à accepter les paiements",
      "payment_disable_text_recurring": "L'option Accepter les paiements n'est pas disponible pour les réunions récurrentes. Désactivez le mode récurrent pour activer les paiements.",
      "date_and_time_selector": "Sélecteur de date et d'heure",
      "form_selector": "Formulaire",
      "order_step": "Étape",
      "widget_order_label": "Ordre des widgets",
      "widget_order_tool_tip": "Réorganisez l'ordre du « Sélecteur de date et d'heure » et du « Formulaire » dans le widget de calendrier. Il vous suffit de faire glisser et de réorganiser selon vos préférences.",
      "widget_re_order_tooltip": "La réorganisation est disponible uniquement avec le style de widget Neo. Passer à Neo pour activer la réorganisation.",
      "widget_re_order_disabled_tooltip": "Pour réorganiser l'ordre des widgets, désactivez « Préférence des nouveaux rendez-vous (Toujours réserver avec l'utilisateur assigné au {contactLabel}) » dans la section Informations sur la réunion > Membres d'équipe > Configuration avancée.",
      "payment_description_error": "Limite maximale de 1 000 caractères atteinte.",
      "widget_multiple_location_disabled_tooltip": "Le widget Classic ne prend pas en charge plusieurs lieux de réunion. Veuillez supprimer tous les lieux supplémentaires pour utiliser ce widget.",
      "recurring_payment_label": "Paiement des rendez-vous récurrents",
      "enable_payments_for_guests": "Activer les paiements pour les invités",
      "guest_payment_description": "Comme vous avez activé l'option « Ajouté à des invités », vous pouvez également fournir le texte que vous souhaitez faire traduire en français.",
      "charge_per_attendee": "Frais par participant",
      "charge_per_attendee_description": "multiplier le montant total via le nombre de participants (y compris les invités) dans le paiement lors de la réservation.",
      "click_confirm_description": "Cliquez sur Enregistrer pour appliquer ces modifications.",
      "multiply_amount_guests": "collecter des paiements pour chaque participant",
      "multiply_amount_guests_description": "Lorsque cette option est activée, le montant à percevoir lors de la réservation sera multiplié par le nombre total de participants, y compris les invités.",
      "first_appointment_only": "frais pour le premier rendez-vous seulement",
      "all_appointments": "frais pour chaque rendez-vous initial",
      "no_payment_provider_connected": "Aucun fournisseur de paiement connecté.",
      "no_default_payment_provider": "Aucun fournisseur de services de paiement connecté",
      "provider_not_supported": "Le fournisseur de services de paiement Par défaut n'est pas pris en charge",
      "manage_payment_provider": "Gérer les fournisseurs de services de paiement",
      "supported_providers": "Fournisseurs pris en charge",
      "paypal_razorpay_helper_text": "Les paiements seront traités uniquement via Razorpay, car PayPal n'est pas pris en charge avec les fournisseurs personnalisés.",
      "rearrange_widget_order": "Réorganiser l'ordre des widgets",
      "change_form_order": "Le formulaire de contact a l'essai in widget",
      "change_form_order_desc": "<b>L'option Préférence des nouveaux rendez-vous (Toujours réserver avec l'utilisateur assigné au {contactLabel})</b> sera désactivée. Cela signifie que les rendez-vous pourront être pris avec n'importe quel membre de l'équipe disponible, au lieu d'être limités à l'utilisateur attribué au {contactLabel}.",
      "enable_mandatory_guest": "Créez au moins une invitation obligatoire. Les champs de Invité seront pré- ouverts et doivent être remplis avant la réservation.",
      "enable_mandatory_guest_count": "Compter obligatoirement le nombre d'invités sur le widget de réservation.",
      "require_guest_for_booking": "Inviter des utilisateurs pour la réservation",
      "sticky_contacts_tooltip": "Remplissez automatiquement les champs pour les {contactsLabel} connus.",
      "auto_confirm_tooltip": "Marquez automatiquement les nouvelles réunions comme confirmées sans approbation manuelle. Désactivez cette option si vous souhaitez examiner et confirmer manuellement chaque réservation avant qu'elle ne soit programmée.",
      "confirm_tooltip": "Lorsque quelqu'un effectue une réservation, vous pouvez choisir de lui afficher un message personnalisé sur la même page (par défaut) ou de le rediriger vers une page de votre choix (URL de redirection).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Activez la collecte des paiements lors des réservations.",
      "total_amount_tooltip": "Fixez le montant total de la réunion.",
      "deposit_amount_tooltip": "Montant de l'acompte à collecter lors de la réservation.",
      "multiply_amount_guests_all_guests": "collecter le paiement pour chaque participant, y compris les invités",
      "multiply_amount_guests_all_guests_tooltip": "Lorsque cette option est activée, le montant à percevoir lors de la réservation sera multiplié par le nombre total de participants, y compris les invités.",
      "payment_description": "Description du paiement",
      "payment_description_desc": "Affiché au client lors de la saisie des informations de paiement.",
      "payment_description_tooltip": "Incluez éventuellement des détails utiles concernant le paiement.",
      "test_mode_warning": "Mode Test dynamique – aucun chiffre d'affaires réel ne sera traité.",
      "pixel_id_tooltip": "Envoyez les activités du widget de réservation, telles que les vues, les clics et les envois, à Meta en utilisant votre ID Pixel.",
      "forms_description": "Définissez vos préférences et options pour la collection des informations client lors des réservations.",
      "payment_mode": "Mode de paiement",
      "payment_mode_tooltip": "Passer du mode Test et du mode direct pour les paiements. in le mode Test, aucune facturation n'est effectuée Passer à le mode direct pour accepter les paiements actuels des clients.",
      "enable_coupon": "Activer les codes de coupon",
      "enable_coupon_tooltip": "Permettez aux clients d'appliquer des codes de réduction lors de la réservation. Pour vous assurer qu'ils fonctionnent, créez d'abord des coupons valides sous Paiements > Codes de réduction.",
      "payment_collection": "Collecte du paiement",
      "payment_collection_tooltip": "Choisissez si vous souhaitez débiter le client au moment de la réservation ou simplement enregistrer sa carte sans le débiter.",
      "charge_upfront": "Facturer à l'avance",
      "save_card_on_file": "Enregistrer la carte dans le dossier",
      "save_card_on_file_desc": "Enregistrez la carte du client en toute sécurité lors de la réservation. Aucuns frais ne sont facturés lors de la réservation.",
      "guests": "Invités"
    },
    "notifications": {
      "third_party_cal": "Paramètres de calendrier tiers",
      "third_party_cal_desc": "Configurer vos préférences pour les calendriers tiers.",
      "additional_settings": "Paramètres supplémentaires",
      "additional_settings_desc": "Configurez des paramètres supplémentaires pour votre calendrier.",
      "notifications": "Notifications",
      "notifications_sub": "Configurez comment vous envoyez les notifications de réservation par e-mail, SMS, WhatsApp, appels vocaux et alertes intégrées à l'application.",
      "edit": "Modifier",
      "created_on": "Créée le",
      "updated_on": "Mis à jour le",
      "delivered": "Envoyé",
      "not_available": "S. O.",
      "select_notification_type": "Sélectionner le type de notification.",
      "notification_person": "Qui doit recevoir cette notification ?",
      "contact": "{contactLabel}",
      "guest": "Invité",
      "assigned_user": "Utilisateur assigné",
      "emails": "E-mails",
      "alert_email_address": "Adresse e-mail d'alerte",
      "ack_email": "E-mail d'accusé de réception",
      "send_google_invites": "Autorisez Google Agenda à envoyer des invitations aux participants ou à mettre à jour des e-mails.",
      "assign_user_to_contact_desc": "Lorsque cette option est activée, l'utilisateur assigné à {contactLabel} correspondra au propriétaire du rendez-vous ayant fait l'objet du changement le plus récent - qu'il ait été réservé, reprogrammé ou réattribué.",
      "send_google_outlook_invites": "Autorisez Google Agenda / Outlook /iCloud à envoyer des invitations aux participants ou à mettre à jour des e-mails.",
      "assign_user_to_contact": "Assignez les {contactsLabel} aux membres d'équipe chargés du calendrier concerné à chaque fois qu'un rendez-vous est pris.",
      "skip_assigning_user_to_contact": "Ignorez l'assignation d'un {contactLabel} si un {contactLabel} lui est déjà assigné.",
      "skip_assigning_user_to_contact_desc": "Lorsque cette option est activée, l'utilisateur assigné à {contactLabel} restera le même, même si le propriétaire du rendez-vous est différent.",
      "assigned_staff": "Personnel assigné",
      "additional_emails": "E-mails supplémentaires",
      "assign_user_to_staff": "Attribuez toujours le contact au propriétaire du rendez-vous.",
      "allow_cancellation": " Autoriser l'annulation de la réunion",
      "allow_reschedule": "Autoriser la reprogrammation de la réunion",
      "allow_cancellation_tooltip": "Lorsque cette option est activée, un lien d'annulation est ajouté à la section des notes supplémentaires et inclus dans l'invitation au calendrier. Ce lien expirera avant l'heure de début de la réunion, ce qui empêchera l'auteur de la réservation d'annuler la réunion.",
      "allow_reschedule_tooltip": " Lorsque cette option est activée, un lien de report est ajouté à la section des notes supplémentaires et inclus dans l'invitation au calendrier. Ce lien expirera avant l'heure de début de la réunion, ce qui empêchera l'auteur de la réservation de reporter la réunion.",
      "cancellation_link_expiry": "Le lien d'annulation expirera",
      "reschedule_link_expiry": "Le lien de report expirera",
      "before_meeting": "avant la réunion",
      "cancellation_and_reschedule_policy": "Politique d'annulation et de report :",
      "meeting_invite_notes": "Notes de l'invitation à la réunion",
      "meeting_invite_notes_tooltip": "Ajoutez des notes qui apparaîtront dans l'invitation de calendrier envoyée aux clients. Ces notes feront l'objet d'une synchronisation avec les calendriers tiers dans la description de la réunion."
    },
    "connections": {
      "connections_heading": "Synchronisation du calendrier externe",
      "booking_channels_heading": "Canaux de réservation",
      "booking_channels_description": "Configurez comment ce calendrier reçoit les réservations des plateformes externes.",
      "connections_sub": "Synchronisez les réunions avec des calendriers externes et gérez la manière dont les événements sont traités.",
      "link_to_calendar": "Lien vers le calendrier",
      "sync_option": "Option de synchronisation",
      "execute_automation": "Exécuter l'automatisation",
      "fire_workflow": "Déclencher des flux de travail pour les événements ajoutés via la synchronisation bidirectionnelle.",
      "reserve_with_google": "Réserver avec Google [Obsolète]",
      "reserve_with_google_setup": "Voir les instructions de configuration",
      "reserve_with_google_configure": "configurer",
      "change": "Modifier",
      "rwg_deprecation_notice": "Google a supprimé <b>Réserver avec Google (Annonces de services locaux).</b> Les nouvelles connexions ou les modifications des connexions existantes ne sont plus prises en charge. Pour continuer à recevoir des réservations de Google, utilisez plutôt <b>Réservation naturelle via Google</b>.",
      "rwg_category": "catégorie",
      "rwg_service_type": "Service",
      "connect_lsa": "Se connecter à votre compte d'annonces de services locaux.",
      "reserve_error": "Actuellement, Réservez avec Google est uniquement pris en charge aux États-Unis pour les secteurs suivants : « services à domicile », « immobilier », « services juridiques » (fournisseurs de services locaux).",
      "one_way": "Unidirectionnelle",
      "two_way": "Bidirectionnel",
      "smart": "Intelligent",
      "confirm_remove": "Voulez-vous vraiment supprimer Google Agenda ?",
      "read_only_access": "Vous n'avez pas accès en écriture à ce calendrier. Veuillez sélectionner un autre calendrier.",
      "reserve_with_google_desc": "Ce service de calendrier sera inscrit dans Réserver avec Google uniquement si l'intégration est réussie.",
      "check_integration": "Vérifier le statut de votre intégration",
      "setup_external": "Configurer le calendrier externe",
      "reserve_price_decimal_error": "Le prix décimal n'est pas pris en charge.",
      "reserve_price_max_error": "Prix pris en charge inférieur à 1 000.",
      "link_to_calendar_tooltip": "Sélectionnez le calendrier externe pour la synchronisation des réunions. Les calendriers Google connectés dans Paramètres du calendrier → Connexions peuvent être sélectionnés.",
      "one_way_sync": "Unidirectionnelle",
      "default_one_way": "Synchronisation par défaut (synchronisation unidirectionnelle)",
      "one_way_sync_desc": "Les événements du calendrier tiers sont synchronisés en tant que créneaux bloqués, et aucun contact n'est créé pour les invités.",
      "two_way_sync": "Synchronisation bidirectionnelle",
      "two_way_sync_desc": "Des contacts sont créés pour les invités trouvés dans les événements du calendrier tiers, et ces événements sont transformés en rendez-vous système.",
      "smart_sync": "Synchronisation intelligente",
      "smart_sync_desc": "Les événements du calendrier tiers sont synchronisés en tant que rendez-vous pour les contacts existants. Si aucun contact n'existe, les événements sont synchronisés comme créneaux bloqués sans créer de nouveau contact.",
      "sync_option_tooltip": "Choisissez comment les événements du calendrier externe sont traités :\n- Unidirectionnel : bloque l'horaire sur ce calendrier sans créer {contactsLabel}\n- Bidirectionnel : crée des réunions et {contactsLabel} à partir des événements du calendrier externe\n- Intelligent : crée des réunions uniquement pour les {contactsLabel} existants et bloque les horaires pour les autres.",
      "default_sync": "Par défaut",
      "default_sync_desc": "Synchroniser les événements de votre calendrier tiers vers ce calendrier.",
      "advanced_sync": "Avancées",
      "advanced_sync_desc": "Synchronise les événements de votre calendrier tiers avec ce calendrier et crée des contacts et des rendez-vous dans le système.",
      "assign_contact_to": "Assigner le contact à",
      "select_calendar": "Sélectionner un calendrier",
      "sync_preferences": "Préférences de synchronisation",
      "sync_preferences_desc": "Comment souhaitez-vous synchroniser les événements de votre calendrier tiers ?",
      "recommended": "Recommandées",
      "execute_automation_desc": "Exécuter l'automatisation quand une réunion est créée dans ce calendrier.",
      "save": "Enregistrer les modifications",
      "cancel": "Annuler",
      "reserve_with_google_title": "Réserver avec Google",
      "current_connection": "Connexion actuellement active :",
      "category": "Catégorie",
      "service": "Type de service",
      "price": "Prix estimé",
      "currency": "Devise",
      "client_portal_booking": "Réservation sur le Portail client",
      "client_portal_booking_description": "Autorisez ce calendrier à apparaître dans la liste de réservation du Portail client."
    },
    "booking_rules": {
      "booking_rules": "Règles de réservation",
      "booking_rules_description": "Contrôlez comment et quand les réunions peuvent être programmées."
    },
    "payments": {
      "payments": "Paiements",
      "payments_description": " Activez et gérez les paiements, les règles et les modèles de tarification."
    },
    "extras": {
      "extras": "Personnalisations",
      "extras_sub": "Définissez le style du widget et d'autres préférences.",
      "calendar_widget_style": "Style du widget de calendrier",
      "neo": "Nouveau",
      "classic": "Classique",
      "insert_custom_code": "Insérer du code personnalisé",
      "show_seats_per_slot": "Afficher les places par créneau",
      "allow_reschedule_meeting": "Autoriser le report de la réunion",
      "allow_cancelling_meeting": "Autoriser l'annulation de la réunion",
      "additional_notes": "Notes supplémentaires",
      "cancellation_and_reschedule": "Annulation et report :",
      "allow_staff": "Autoriser la sélection du personnel lors de la réservation",
      "code_block_tooltip": "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités intéressantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Nous vous recommandons donc de vérifier le contenu de ce script avant de l'enregistrer dans le calendrier.",
      "calendar_image": "Image de couverture du calendrier",
      "remove_image": "Supprimer l'image",
      "calendar_image_info": "L'image importée sera visible dans la Vue de groupe pour le modèle Neo et n'apparaîtra pas sur le lien du calendrier concerné.",
      "get_image_from_unsplash": "Améliorez vos visuels avec",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Configurer des préférences supplémentaires",
      "service_image": "Image de couverture du service",
      "service_image_description": "Sélectionnez une image qui sera affichée dans le menu de services pour ce service.",
      "allow_reschedule_appointment": "Autoriser le report du rendez-vous",
      "allow_cancelling_appointment": "Autoriser l'annulation du rendez-vous",
      "custom_code_placeholder": "Saisissez le code personnalisé ici",
      "calendar_widget_style_desc": "Choisissez entre notre widget Classic ou l'élégant widget Neo.",
      "seats_per_slot": "Places par créneau",
      "show_staff_selection": "Sélection du personnel",
      "seats_per_slot_desc": " Permettez aux auteurs de réservation de voir le nombre de places disponibles pour chaque créneau directement sur le widget de calendrier.",
      "show_staff_selection_desc": "Permettez aux auteurs de réservation de choisir un membre du personnel directement à partir du widget de calendrier lors de la prise de rendez-vous. Fonctionne uniquement avec le widget Neo.",
      "widget_re_order_tooltip": "Le style de widget Classic ne permet pas de modifier l'ordre des widgets. Assurez-vous que le Sélecteur de date et d'heure est positionné en premier et que le Formulaire est en second avant de sélectionner le style Classic.",
      "show_staff_selection_desc_service": "Permettez aux auteurs de réservation de choisir un membre du personnel directement à partir du widget de calendrier lors de la prise de rendez-vous.",
      "switch_to_classic_widget": "Passer au widget classique",
      "switch_to_classic_widget_desc": "L'activation du <b>widget classique</b> désactivera automatiquement les paramètres suivants, car ils ne peuvent pas coexister :",
      "form_first_disabled": "<b>Le formulaire sera déplacé vers la deuxième étape</b> in l'essai de widget .",
      "appointment_preference_disabled": "<b>L'option Préférence des nouveaux rendez-vous (Toujours réserver avec l'utilisateur assigné au {contactLabel})</b> sera désactivée. Cela signifie que les rendez-vous pourront être pris avec n'importe quel membre de l'équipe disponible, au lieu d'être limités à l'utilisateur attribué au {contactLabel}.",
      "multiple_location_disabled": "<b>L'adresse de plusieurs conférences</b> sera supprimée, et seul le <b>premier emplacement ajouté</b> sera conservé.",
      "insert_custom_code_tooltip": "Personnalisez le style du widget à l'aide de votre propre code CSS.",
      "classic_tooltip_disabled": "Le widget Classic n'est pas pris en charge pour les calendriers de réservation de cours.",
      "show_staff_selection_disabled_tooltip": "La sélection du personnel est prise en charge uniquement pour le widget Neo."
    },
    "roomsAndEquipments": {
      "title": "Salles et équipements sélectionnés",
      "description": "Sélectionnez dans une liste de salles et d'équipements ce qui sera réservé dans ce calendrier.",
      "rooms": "Sélectionner des salles",
      "equipments": "Sélectionner des équipements"
    }
  },
  "activity_log": {
    "activity_log": "Journal d'activité",
    "date": "Date",
    "filter_by": "Filtrer par",
    "calendar_update": "Mise à jour du calendrier",
    "start_time_update": "Mise à jour de l'heure de début",
    "end_time_update": "Mise à jour de l'heure de fin",
    "title_update": "Mise à jour du titre",
    "notes_update": "Mise à jour des notes",
    "appointment_status_update": "Mise à jour du statut du rendez-vous",
    "meeting_location_update": "Mise à jour de l'emplacement de la réunion",
    "google_sync_update": "Mise à jour de la synchronisation Google",
    "outlook_sync_update": "Mise à jour de la synchronisation Outlook",
    "assigned_user_update": "Mise à jour de l'utilisateur assigné",
    "appointment_status": "Statut du rendez-vous",
    "assigned_user": "Utilisateur assigné",
    "uploaded_to": "Importé vers",
    "cancelled": "Annulé",
    "edited": "modifié",
    "other_edits": "Autres modifications",
    "view_details": "Afficher les détails",
    "all": "Tout"
  },
  "appointment_list": {
    "group_all": "TOUT",
    "group_primary": "PRINCIPAL",
    "group_user": "UTILISATEURS",
    "group_team": "GROUPES",
    "group_calendar": "CALENDRIERS",
    "all_appointments": "Tous les rendez-vous",
    "my_calendar": "Mon calendrier",
    "status_all": "Tout",
    "status_confirmed": "Confirmé",
    "status_new": "Nouveau (action requise)",
    "status_show": "Honoré",
    "status_no_show": "Non honoré",
    "status_cancelled": "Annulé",
    "status_invalid": "Non valide",
    "filter_date_added_desc": "Date d'ajout (ordre décroissant)",
    "filter_start_added_desc": "Date de début (ordre décroissant)",
    "filter_start_added_asc": "Date de début à partir d'aujourd'hui (ordre croissant)",
    "button_new_appointment": "Nouveau rendez-vous",
    "name": "Nom",
    "title": "Titre",
    "requested_time": "Heure demandée",
    "date_added": "Date d'ajout",
    "calendar": "Calendrier",
    "appointment_owner": "Propriétaire du rendez-vous",
    "notes": "Notes",
    "status": "Statut",
    "action_view_detail": "Afficher les détails",
    "action_view_consent": "Afficher le consentement",
    "action_view_notes": "Afficher les remarques",
    "action_edit": "Modifier",
    "action_delete": "Supprimer",
    "action_reschedule": "Reporter",
    "page_previous": "Précédent",
    "page_next": "Suivant",
    "appointment_notes": "Notes de rendez-vous",
    "close": "Fermer",
    "confirm_delete_header": "Supprimer le rendez-vous",
    "confirm_delete_message": "Voulez-vous vraiment supprimer ce rendez-vous ? Cette action est irréversible !",
    "confirm_delete_button": "Supprimer",
    "confirm_update_header": "Mettre à jour le statut du rendez-vous",
    "confirm_update_confirmed_message": "Voulez-vous vraiment marquer ce rendez-vous comme confirmé ?",
    "confirm_update_invalid_message": "Voulez-vous vraiment marquer ce rendez-vous comme non valide ?",
    "confirm_update_showed_message": "Voulez-vous vraiment marquer ce rendez-vous comme honoré ?",
    "confirm_update_noshow_message": "Voulez-vous vraiment marquer ce rendez-vous comme non non honoré ?",
    "confirm_update_cancelled_message": "Voulez-vous vraiment marquer ce rendez-vous comme annulé ?",
    "confirm_update_button": "Mettre à jour",
    "empty_state_title": "Aucun rendez-vous trouvé",
    "empty_state_description": "Aucun rendez-vous trouvé.",
    "disable_menu_warning": "Vous n'avez pas l'autorisation d'afficher ou de modifier les informations relatives au rendez-vous car le contact associé ne vous a pas été assigné. Veuillez contacter votre administrateur pour obtenir de l'aide.",
    "no_contact_warning": "Vous ne pouvez pas accéder aux coordonnées pour le moment. Cela peut être dû au fait que le contact ne vous est pas assigné. Veuillez contacter votre administrateur pour obtenir de l'aide.",
    "consent_label": "Consentement",
    "ip_address": "IP",
    "youre_viewing_in": "Actuellement affiché dans",
    "appointment_delete_msg": "<b>Remarque :</b> le rendez-vous supprimé ici ne sera pas supprimé de Calendly.",
    "rescheduled": "Reporté"
  },
  "add_guest": {
    "guest_label": "Invité(s)",
    "search_placeholder": "Rechercher parmi les contacts",
    "add_new": "Ajouter un nouveau",
    "save": "Enregistrer",
    "close": "Fermer",
    "name": "Nom",
    "phone": "Téléphone",
    "email": "E-mail",
    "guest_label_count": "Nombre d'invité(s)",
    "guest_count_error": "Le nombre d'invités doit être compris entre 1 et 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Informations sur le menu de services",
    "select_groups_header": "Sélectionner des services",
    "arrange_groups_header": "Organiser vos services",
    "new_service_menu": "Nouveau menu de services",
    "service_menu_sub_title": "Créez un menu de services personnalisé pour vos clients en quelques clics",
    "quick_tip": "Vous pouvez ajouter des groupes au menu de services",
    "service_menu_name": "Nom du menu de services",
    "service_menu_description": "Description",
    "service_menu_slug": "URL du service",
    "select_groups_calendars": "Sélectionner des groupes et des calendriers",
    "select_groups_calendars_desc": "Ajouter des services à votre menu de services",
    "select_all": "Sélectionner tout",
    "arrange_groups": "Organiser l'ordre des services",
    "arrange_groups_desc": "Déterminer l'ordre des services dans le menu de services",
    "arrange_services_quicktip": "Pour réorganiser les calendriers au sein d'un groupe, accédez à Groupes > Options > Réorganiser les calendriers.",
    "enable_add_guest_desc": "Permet aux clients d'inclure des invités supplémentaires lors de la réservation.",
    "enable_multiple_service_desc": "Permet aux clients de réserver plusieurs services en un seul rendez-vous.",
    "enable_staff_selection_desc": "Permet aux clients de sélectionner les membres du personnel qu'ils préfèrent lorsqu'ils effectuent une réservation.",
    "enable_add_guest": "Activer l'ajout d'invités",
    "enable_multiple_service": "Activer la sélection de plusieurs services",
    "enable_staff_selection": "Activer la sélection du personnel",
    "additional_options": "Options supplémentaires",
    "code_block_tooltip": "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités intéressantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Nous vous recommandons donc de vérifier le contenu de ce script avant de l'enregistrer dans le menu de services.",
    "custom_code_placeholder": "Saisissez le code personnalisé ici",
    "insert_custom_code": "Insérer du code personnalisé",
    "no_service": "Aucun service trouvé",
    "no_service_desc": " Aucun service trouvé. Créez des services et ajoutez-les à des groupes pour créer un menu de services.",
    "learn_more": "En savoir plus",
    "no_service_selected": "Aucun service sélectionné",
    "create_service_calendars": "Créer des calendriers de service",
    "alert_description": " Pour créer un menu de services, vous devez créer des calendriers de service et les ajouter à des groupes.",
    "dont_show_again": "Ne plus afficher",
    "service_name_required": "Le nom du menu de services est obligatoire",
    "slug_already_taken": "Ce slug est déjà pris",
    "slug_required": "Le slug est obligatoire",
    "please_enter_name": "Veuillez saisir un nom",
    "service_name_placeholder": "Menu principal",
    "service_slug_placeholder": "menu principal",
    "form_label": "Formulaire",
    "consent_label": "Case de consentement",
    "consent_input_placeholder": "Ajouter un texte de consentement",
    "consent_tooltip": "Activez cette option pour autoriser l'obtention du consentement des {contactsLabel} lorsqu'ils fournissent leur numéro de téléphone lors de la prise de rendez-vous.",
    "back_message": "Retour à la liste",
    "saving_changes": "Il minute suffit d'enregistrer le dernier enregistrement dynamique",
    "payment_provider_warning": "Attention : Les menus de service ne prennent actuellement en charge que les paiements par Stripe et Authorize.net. Étant donné que vous utilisez un autre fournisseur par défaut, l'encaissement des paiements pour les calendriers sélectionnés dont les paiements sont activés sera ignoré.",
    "aria": {
      "consent_form_toggle": "Bouton bascule de formulaire de consentement",
      "enable_add_guest_toggle": "Bouton bascule d'ajout d'invité",
      "enable_multiple_services_toggle": "Bouton bascule d'activation de plusieurs services",
      "enable_staff_selection_toggle": "Bouton bascule de sélection du personnel"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Personnaliser le widget de calendrier",
    "works_with_neo_widget": "Fonctionne uniquement avec le widget Neo",
    "customise_widget_desc": "Personnalisez l'apparence du widget : couleur principale, couleur d'arrière-plan et texte des boutons.",
    "learn_more": "En savoir plus",
    "primary_settings": "Paramètres principaux",
    "primary_settings_desc": "Configurez la couleur principale, la couleur d'arrière-plan et d'autres préférences du widget pour personnaliser votre widget de calendrier.",
    "primary_color": "Couleur principale",
    "primary_color_desc": "Définissez la couleur des boutons, des dates, des créneaux et des actions.",
    "background_color": "Couleur d'arrière-plan",
    "background_color_desc": "Définissez la couleur d'arrière-plan qui sert de toile de fond au sélecteur de date et d'heure et au formulaire.",
    "button_text": "Texte du bouton",
    "button_text_desc": "Personnalisez le texte affiché sur le bouton lors de la prise de rendez-vous.",
    "calendar_title": "Titre du calendrier",
    "calendar_title_desc": "Le nom de votre calendrier",
    "calendar_description": "Description du calendrier",
    "calendar_description_desc": "La description saisie.",
    "calendar_details": "Détails du calendrier",
    "calendar_details_desc": "Comprend des informations telles que la durée, la date et l'heure, les informations récurrentes et le fuseau horaire.",
    "reset_to_default": "Réinitialiser les paramètres par défaut",
    "preview_widget": "Aperçu du widget",
    "calendar_title_tooltip": "Déterminez si le nom du calendrier et le nom du groupe (le cas échéant) doivent être visibles sur le widget de réservation.",
    "calendar_description_tooltip": "Déterminez si la description du calendrier doit être visible sur le widget de réservation.",
    "calendar_details_tooltip": "La collection de la durée totale des réunions telles que la durée de la réservation, la Date et la Date de clôture, et les informations de récurrence (si applicables) doivent être visibles dans le widget de réservation.",
    "insert_custom_code_tooltip": "Personnalisez widget le style via votre propre CSS code.",
    "staff_selection_tooltip": "client pour ajouter un membre du personnel directement au widget de calendrier lors de la réservation. Fonctionne uniquement avec le widget Neo."
  },
  "eventNotification": {
    "customFields": "Champs personnalisés",
    "customValues": "Valeurs personnalisées",
    "templateVariableIssueDefaultPartBefore": "Nous rencontrons des problèmes avec vos ",
    "templateVariableIssueDefaultPartHighlight": "valeurs personnalisées",
    "templateVariableIssueDefaultPartAfter": "; veuillez les vérifier et les corriger avant d'enregistrer.",
    "templateVariableInvalidListOverflow": "… et {count} de plus",
    "templateVariableIssueSingle": "Il y a un problème avec cette valeur personnalisée : {value}; veuillez la corriger avant de l'enregistrer.",
    "templateVariableIssueEmpty": "Une ou plusieurs valeurs personnalisées sont vides ({emptyPair}) ; veuillez ajouter un champ valide entre les crochets.",
    "templateVariableIssueMarkup": "Certaines valeurs personnalisées incluent du HTML ou du formatage, ce qui n'est pas pris en charge ; veuillez les supprimer avant de sauvegarder.",
    "templateVariableSaveFailed": "Impossible d'enregistrer la notification {receiverLabel}. Veuillez corriger les erreurs de valeurs personnalisées avant d'enregistrer.",
    "templateVariableSaveFailedGeneric": "Impossible d'enregistrer la notification. Veuillez corriger les erreurs de valeurs personnalisées avant d'enregistrer.",
    "guest": "Invité",
    "assignedUser": "Utilisateur assigné",
    "additionalEmails": "E-mails supplémentaires",
    "list": {
      "booked": {
        "title": "Rendez-vous réservé (statut : Non confirmé)",
        "modalTitle": "rendez-vous réservé (Statut : Non confirmé)",
        "note": "Cette notification est envoyée lorsqu'un nouveau rendez-vous est créé avec un statut non confirmé.",
        "subTitle": "Avertit lorsqu'un rendez-vous est pris avec un statut Non confirmé."
      },
      "confirmation": {
        "title": "Rendez-vous réservé (statut : Confirmé)",
        "modalTitle": "Rendez-vous réservé (statut : Confirmé)",
        "note": "Cette notification est totale lorsqu'un rendez-vous est créé sans mis à jour le statut de confirmation.",
        "subTitle": "Avertit lorsqu'un rendez-vous a bien été confirmé."
      },
      "cancellation": {
        "title": "Annulation",
        "modalTitle": "annulation",
        "note": "Cette notification est totale lorsqu'un rendez-vous est annulé, marqué comme non valide.",
        "subTitle": "Avertit en cas d'annulation d'un rendez-vous."
      },
      "reschedule": {
        "title": "Reporter",
        "modalTitle": "reporter",
        "note": "Cette notification est envoyée lorsqu'un rendez-vous est reprogrammé. Il sera activé si le rendez-vous est in le statut non confirmé ou confirmé.",
        "subTitle": "Avertit lorsqu'un rendez-vous est reporté."
      },
      "reminder": {
        "title": "rappel",
        "modalTitle": "rappel",
        "note": "Cette notification est envoyée en tant que rappel avant le rendez-vous. Il sera activé si le rendez-vous est in le statut non confirmé ou confirmé.",
        "subTitle": "Envoie un rappel avant le rendez-vous."
      },
      "followup": {
        "title": "suivi",
        "modalTitle": "suivi",
        "note": "Cette notification est envoyée après le rendez-vous en tant que suivi. Il sera activé si le rendez-vous est in le statut non confirmé, confirmé, ou honoré.",
        "subTitle": "Envoie un message de suivi une fois le rendez-vous terminé."
      }
    },
    "saveToastMsg": "Paramètres enregistrés !",
    "saveToastMsgDesc": "Vos modifications ont bien été enregistrées.",
    "enableSuccess": "Notifications activées !",
    "disableSuccess": "Notifications désactivées !",
    "tooltip": "Cette notification a été refusée. Veuillez l'activer pour créer une dynamique.",
    "enabled": "activé",
    "disabled": "Désactivé",
    "statusLabel": "Étiquettes de statut",
    "email": {
      "channelName": "des E-mail",
      "noneTemplate": "Aucune",
      "notificationLabel": "Qui doit recevoir cette notification ?",
      "sendButtonLabel": "Envoyer un e-mail de test",
      "testEmailLabel": "E-mail de test",
      "testEmailPlaceholder": "Saisissez l'adresse e-mail du destinataire pour le test",
      "body": "Corps de l'e-mail",
      "bodyPlaceholder": "Saisissez votre message ici",
      "subject": "Objet",
      "subjectPlaceholder": "Saisissez l'objet de l'e-mail",
      "templateLabel": "Modèle d'e-mail",
      "templatePlaceholder": "Sélectionnez un modèle d'e-mail ou partez de zéro",
      "fromNamePlaceholder": "Entrer le nom",
      "fromNameLabel": "Nom de l'expéditeur",
      "fromAddressLabel": "Adresse de provenance",
      "alertEmailAddress": "Entrer les identifiants d'e-mail (séparés par des virgules)",
      "addMore": "Ajouter plus",
      "afterAppointmentEnds": "après la fin du rendez-vous",
      "beforeAppointmentStarts": "avant le début du rendez-vous",
      "durationLabel": "Quand souhaitez-vous déclencher la notification ?",
      "disableEmailNotification": "Désactiver les notifications par e-mail",
      "enableEmailNotification": "Activer les notifications par e-mail",
      "enableSuccess": "Notification par e-mail activée !",
      "enableSuccessDesc": "Vous allez à présent recevoir cette notification",
      "disableSuccess": "Notification par e-mail désactivée !",
      "disableSuccessDesc": "Vous ne recevrez plus cette notification",
      "reset_to_default": "par défaut",
      "testEmailSuccessTitle": "E-mail de test envoyé !",
      "testEmailSuccessDesc": "L'e-mail de test a été envoyé avec succès à {email}",
      "testEmailErrorTitle": "Échec de l'envoi de l'e-mail de test",
      "testEmailErrorDesc": "Une erreur s'est produite lors de l'envoi de l'e-mail de test. Veuillez réessayer.",
      "create_new_email_template": "Créer un nouveau modèle d'e-mail",
      "templateVariableFieldSubject": "Ligne d'objet",
      "templateVariableFieldFromName": "Nom de l'expéditeur",
      "templateVariableFieldFromAddress": "Adresse de l'expéditeur",
      "templateVariableFieldEmailBody": "Corps de l'e-mail"
    },
    "inApp": {
      "channelName": "in-application",
      "title": "Paramètres de notification",
      "enableInAppNotification": "Activer la notification in-app",
      "disableInAppNotification": "Désactiver la notification in-app",
      "selectedUser": {
        "label": "Envoyer à",
        "helperText": "Cette notification interne est envoyée via le Web et les applications mobiles.",
        "placeholder": "Sélectionner un ou plusieurs utilisateurs"
      },
      "enableSuccess": "Notifications in-app activées.",
      "enableSuccessDesc": "Vous allez maintenant commencer à recevoir cette notification.",
      "disableSuccess": "Notifications in-app désactivées.",
      "disableSuccessDesc": "Vous ne recevrez plus cette notification."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Aucun",
      "notificationLabel": "Qui doit recevoir cette notification ?",
      "sendButtonLabel": "Envoyer un SMS de test",
      "testSMSLabel": "SMS de test (saisissez le numéro de téléphone avec l'indicatif du pays)",
      "testSMSPlaceholder": "+12345678901",
      "body": "SMS",
      "bodyPlaceholder": "Saisissez votre message SMS ici",
      "durationLabel": "Quand voulez-vous déclencher la notification ?",
      "disableSMSNotification": "Désactiver les notifications par SMS",
      "enableSMSNotification": "Activer les notifications par SMS",
      "enableSuccess": "Notification par SMS activée !",
      "enableSuccessDesc": "Vous allez maintenant commencer à recevoir cette notification.",
      "disableSuccess": "Notification par SMS désactivée.",
      "disableSuccessDesc": "Vous ne recevrez plus cette notification.",
      "alertPhoneNumbers": "Saisir les numéros de téléphone (avec les indicatifs des pays, séparés par des virgules)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Ajouter plus",
      "afterAppointmentEnds": "après la fin du rendez-vous",
      "beforeAppointmentStarts": "avant le début du rendez-vous",
      "templateLabel": "Modèle de SMS",
      "templatePlaceholder": "Sélectionner un modèle de SMS…",
      "reset_to_default": "Revenir aux paramètres par défaut",
      "testSmsSuccessTitle": "SMS de test envoyé.",
      "testSmsSuccessDesc": "Le SMS de test a été envoyé avec succès à {phone}.",
      "testSmsErrorTitle": "Impossible d'envoyer le SMS de test",
      "testSmsErrorDesc": "Une erreur s'est produite lors de l'envoi du SMS de test. Veuillez réessayer.",
      "templateVariableFieldSmsBody": "Corps du message"
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Qui doit recevoir cette notification ?",
      "sendButtonLabel": "Envoyer une notification WhatsApp de test",
      "testWhatsAppLabel": "Notification WhatsApp de test (saisissez le numéro de téléphone avec l'indicatif du pays)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "Quand voulez-vous déclencher la notification ?",
      "alertPhoneNumbers": "Saisir les numéros de téléphone (avec les indicatifs des pays, séparés par des virgules)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Ajouter plus",
      "afterAppointmentEnds": "après la fin du rendez-vous",
      "beforeAppointmentStarts": "avant le début du rendez-vous",
      "templateLabel": "Modèle WhatsApp",
      "templatePlaceholder": "Sélectionnez un modèle WhatsApp...",
      "noPreview": "Aucun modèle sélectionné",
      "templateRequired": "Modèle obligatoire",
      "testWhatsAppSuccessTitle": "Notification de test WhatsApp envoyée !",
      "testWhatsAppSuccessDesc": "La notification WhatsApp de test a bien été envoyée à {phone}.",
      "testWhatsAppErrorTitle": "Échec de l'envoi de la notification WhatsApp de test.",
      "testWhatsAppErrorDesc": "Une erreur s'est produite lors de l'envoi de la notification WhatsApp de test. Veuillez réessayer.",
      "setupTitle": "Contactez votre client sur son application de messagerie préférée.",
      "setupDescription": "Restez plus proche de vos clients en offrant une assistance immédiate, en envoyant des mises à jour opportunes et en créant des interactions captivantes.",
      "connectWhatsApp": "Connecter WhatsApp",
      "checkingStatus": "Vérification du statut du compte WhatsApp…",
      "checkingTemplateStatus": "Vérification du statut du modèle WhatsApp…",
      "statusCheckError": "Échec de la vérification du statut du compte WhatsApp.",
      "templateStatusCheckError": "Échec de la vérification du statut du modèle WhatsApp.",
      "setupTemplateTitle": "Terminez la configuration de votre modèle WhatsApp.",
      "setupTemplateDescription": "Vous devez configurer les modèles WhatsApp avant de pouvoir envoyer des notifications. Cliquez ci-dessous pour terminer le processus de configuration.",
      "loadTemplatesError": "Échec du chargement des modèles WhatsApp.",
      "templatesRefreshed": "Modèles actualisés avec succès",
      "templatesRefreshError": "Échec de l'actualisation des modèles.",
      "templatesResolveError": "Échec de la résolution des modèles WhatsApp par défaut.",
      "locationNotFound": "ID d'emplacement introuvable.",
      "settingsRedirectError": "Impossible de rediriger vers les configurations WhatsApp.",
      "updateNotificationError": "Échec de la mise à jour de la notification WhatsApp.",
      "notificationsEnabled": "Notifications WhatsApp activées !",
      "notificationsDisabled": "Notifications WhatsApp désactivées !",
      "updateError": "Erreur lors de la mise à jour des notifications.",
      "createNewTemplate": "Créer un nouveau modèle WhatsApp",
      "phoneValidation": {
        "countryCodeRequired": "Le numéro de téléphone doit commencer par un indicatif de pays (par exemple, +1, +91, +44)",
        "digitsOnly": "Le numéro de téléphone doit contenir uniquement des chiffres après l'indicatif du pays.",
        "tooShort": "Le numéro de téléphone est trop court.",
        "tooLong": "Le numéro de téléphone est trop long.",
        "invalid": "Numéro de téléphone non valide."
      },
      "errors": {
        "templateNotFound": "ID de modèle non trouvé dans les options chargées. Suppression…",
        "templateNoLongerValid": "Le modèle enregistré n'est plus valide. Suppression…",
        "invalidTemplateSelection": "Tentative de sélection d'un modèle WhatsApp non valide.",
        "fetchingTemplates": "Erreur lors de la récupération des modèles WhatsApp.",
        "mountingCreator": "Échec lors du montage du créateur de modèles WhatsApp.",
        "fetchingAfterCreation": "Échec lors de la récupération des modèles WhatsApp après leur création.",
        "updateStatus": "Erreur de mise à jour du statut WhatsApp."
      },
      "receiverLabels": {
        "assignedUser": "Utilisateur assigné",
        "phoneNumbers": "Numéros de téléphone supplémentaires"
      }
    },
    "voiceAi": {
      "channelName": "Voice AI",
      "setupTitle": "Terminez la configuration de Voice AI",
      "setupDescription": "Les rappels Voice AI nécessitent que quelques éléments soient en place avant de pouvoir les configurer.",
      "agentLabel": "Agent vocal",
      "agentPlaceholder": "Sélectionnez un agent",
      "agentHelper": "L'agent qui place l'appel de rappel. Un agent doit être enregistré une fois avant de pouvoir être utilisé.",
      "openAgent": "Ouvrir l'agent",
      "fromNumberLabel": "Appel provenant de",
      "fromNumberPlaceholder": "Sélectionnez un numéro",
      "timingLabel": "Quand l'appel doit-il être passé ?",
      "beforeAppointment": "avant le début du rendez-vous",
      "timingHelper": "Les appels sont passés entre 8 h et 20 h, heure locale du contact. Avec ce réglage, les rendez-vous commençant entre {from} et {until} seront appelés.",
      "timingRangeError": "Choisissez entre {min} et {max} {unit}.",
      "units": {
        "minutes": "Minutes",
        "hours": "Heures",
        "days": "Jours"
      },
      "consent": {
        "label": "J'accepte les conditions des appels sortants",
        "updatedLabel": "J'accepte les conditions mises à jour des appels sortants",
        "note": "Cette demande ne vous sera faite qu'une seule fois pour ce compte.",
        "updatedNote": "Les conditions ont changé depuis votre dernière acceptation. Les accepter est facultatif.",
        "termsTitle": "Conditions générales",
        "termsIntro": "By activating this feature, you confirm and agree that your business:",
        "terms1": "Will not use this feature in violation of applicable laws governing the making and sending of calls, including but not limited to the Telephone Consumer Protection Act (TCPA), the Telemarketing Sales Rule (TSR), applicable state telemarketing laws, and any equivalent international laws and regulations applicable to your use.",
        "terms2": "Has secured the correct level of consent from each individual before placing calls.",
        "terms3": "Is solely responsible for your compliant use of this functionality.",
        "required": "Acceptez les conditions des appels sortants pour activer les rappels Voice AI."
      },
      "guidelines": {
        "title": "Fonctionnement des appels de rappel",
        "window": "Les appels ne sont passés qu'entre 8 h et 20 h, heure locale du contact, déterminée à partir de son numéro de téléphone.",
        "oncePerDay": "Chaque contact est appelé au plus une fois par jour, donc un seul appel de rappel est passé par rendez-vous.",
        "queued": "Les appels sont mis en file d'attente : la numérotation peut commencer quelques minutes après l'heure du rappel.",
        "skips": "Les contacts qui ont refusé les appels IA ou activé Ne pas déranger sont ignorés.",
        "country": "Les appels ne sont passés qu'à des numéros du pays de ce compte.",
        "fallback": "Si l'appel ne peut pas être passé ou reste sans réponse, le rappel par {channel} est envoyé à la place.",
        "noFallback": "Aucun autre canal de rappel n'est activé : si l'appel ne peut pas être passé ou reste sans réponse, aucun rappel ne sera envoyé.",
        "capabilities": "Si la prise de rendez-vous de l'agent autorise la reprogrammation et l'annulation, le client peut reprogrammer ou annuler pendant l'appel."
      },
      "blockers": {
        "noAgent": "Publiez au moins un agent vocal.",
        "noNumber": "Ajoutez un numéro de téléphone d'où les appels proviennent.",
        "notEnabled": "Activez Voice AI pour ce compte."
      },
      "agentRequired": "Sélectionnez un agent pour passer l'appel de rappel.",
      "fromNumberRequired": "Sélectionnez le numéro depuis lequel l'appel de rappel sera passé.",
      "saveError": "Impossible d'enregistrer les paramètres de rappel Voice AI. Veuillez réessayer."
    }
  },
  "smsTemplate": {
    "create_new_template": "Créer un nouveau modèle de SMS",
    "create_new_template_desc": "Créez un modèle de SMS réutilisable pour vos notifications.",
    "template_name": "Nom du modèle",
    "template_name_placeholder": "Saisissez le nom du modèle",
    "message": "Message",
    "message_placeholder": "Saisissez votre message SMS ici.",
    "create_template": "Créer un modèle",
    "name_required": "Le nom du modèle est obligatoire",
    "text_required": "Le texte du message est obligatoire",
    "fetch_new_templates": "Actualiser les modèles",
    "characters": "caractères",
    "words": "mots",
    "segments": "segments"
  },
  "whatsappTemplate": {
    "create_new_template": "Créer un nouveau modèle WhatsApp",
    "create_new_template_desc": "Créez un modèle WhatsApp réutilisable pour vos notifications.",
    "template_name": "Nom du modèle",
    "template_name_placeholder": "Saisissez le nom du modèle",
    "message": "Message",
    "message_placeholder": "Saisissez votre message WhatsApp ici.",
    "create_template": "Créer un modèle",
    "name_required": "Le nom du modèle est obligatoire",
    "text_required": "Le texte du message est obligatoire",
    "fetch_new_templates": "Actualiser les modèles"
  },
  "archivedServices": {
    "servicesBanner": "Une nouvelle version améliorée des services est arrivée : plus puissante, plus flexible et plus intuitive. Vos calendriers de service ont déjà été migrés. Découvrez-les dès maintenant dans l'onglet Services.",
    "archivedServiceCalendars": "Calendriers de services (v1)",
    "check_new_services": "Vérifier les nouveaux services"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Modifier le calendrier",
      "share_calendar": "Partager le calendrier",
      "troubleshoot_calendar": "Diagnostiquer le calendrier",
      "more_options": "Plus d'options",
      "edit_calendar_desc": "gérer les paramètres du calendrier",
      "share_calendar_desc": "copier et partager votre lien de réservation afin que le client puisse facilement le calendrier avec vous.",
      "troubleshoot_calendar_desc": "Découvrez pourquoi un créneau ne s'affiche pas et examinez les raisons potentielles dans l'affichage de résolution des problèmes.",
      "more_options_desc": "Paramètres et activités supplémentaires pour gérer votre calendrier.",
      "read_permissions": {
        "share_description": "Accordez l'accès à d'autres personnes en partageant le lien vers le calendrier ou en modifiant les autorisations.",
        "troubleshoot_description": "Identifier et résolvez les problèmes tels que les erreurs de synchronisation ou les événements manquants afin d'assurer le bon fonctionnement du système."
      },
      "next": "Suivant",
      "start_over": "Redémarrer",
      "all_set": "Tout est prêt !",
      "previous": "Précédent"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Sélectionnez votre expérience d'édition",
    "select_editing_experience_desc": "Faites votre choix entre notre éditeur de conception visuel par glisser-déposer et notre puissant éditeur de code.",
    "design_editor": "Éditeur de conception",
    "design_editor_desc": "Éditeur visuel en glisser-déposer.",
    "code_editor": "Éditeur de code",
    "code_editor_desc": "Édition HTML riche en fonctionnalités.",
    "text_editor": "Éditeur de texte brut",
    "text_editor_desc": "Éditeur de texte simple et épuré.",
    "email_text_block": "L'email peut également être créé via le bloc de corps. ",
    "select": "Sélectionner",
    "new_template": "Nouveau modèle",
    "email_block": "Un e-mail peut également être créé à l'aide d'un bloc de texte.",
    "fetch_new_templates": "Récupérer de nouveaux modèles"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Utilisez un nom et une description de réunion clairs pour que les personnes qui réservent sachent exactement ce qu'elles planifient.",
      "groups_share_link": "Les groupes vous permettent de partager un lien de réservation pour plusieurs calendriers, ce qui permet aux clients de choisir et de réserver parmi les options disponibles."
    },
    "staff_location": {
      "custom_location": "Choisissez « Personnalisé » comme emplacement de réunion pour entrer une adresse ou un lien de votre choix.",
      "ask_booker_location": "Lorsque l'option Demandez au client est sélectionnée, le client est invité à entrer l'emplacement de la réunion lors de la réservation",
      "round_robin_priority": "Les paramètres de priorité influencent la répartition des réunions lorsque plusieurs membres du personnel sont disponibles.",
      "connect_video_integrations": "Connectez les intégrations de visioconférence depuis Paramètres du calendrier → Connexions avant de les sélectionner comme emplacement de réunion."
    },
    "availability": {
      "staff_availability_required": "Les réunions ne peuvent être réservées que lorsqu'au moins un membre du personnel sélectionné est disponible.",
      "use_precreated_schedule": "Vous pouvez utiliser des horaires de disponibilité préétablis depuis Paramètres du calendrier → Disponibilité ou créer un horaire personnalisé uniquement pour ce calendrier.",
      "timezone_in_schedule": "Le fuseau horaire des réunions est défini dans le calendrier de disponibilité choisi.",
      "event_24_hours": "Pour que le calendrier soit disponible sur 24 heures, définissez la portée horaire de minuit à minuit."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Les règles de réservation s'appliquent à toutes les réunions de ce calendrier, peu importe la disponibilité du personnel.",
      "minimum_scheduling_notice": "Augmentez le délai de préavis minimum pour éviter les réservations de dernière minute.",
      "maximum_bookings_per_slot": "Utilisez un nombre maximal de réservations par créneau pour limiter le nombre de réunions pouvant se dérouler simultanément."
    },
    "forms": {
      "custom_contact_fields": "Vous pouvez inclure des champs de contact personnalisés à la fois dans les messages de formulaire et les URL de formulaire.",
      "create_custom_form": "Pour collecter plus d'informations, créez un formulaire personnalisé dans Sites → Formulaires → Créateur et utilisez-le avec ce calendrier."
    },
    "payments": {
      "collected_during_booking": "Les paiements sont collectés lors de la réservation et doivent être terminés avant que la réunion ne soit confirmée.",
      "payment_description": "Utilisez la description du paiement pour expliquer clairement à quoi correspondent les frais."
    },
    "notifications": {
      "review_policies": "Examinez les politiques d'annulation et de reprogrammation afin d'éviter les changements de dernière minute.",
      "use_workflows": "Pour une automatisation avancée, utilisez les flux de travail avec le déclencheur Rendez-vous réservé."
    },
    "customizations": {
      "preview_widget": "Prévisualisez le widget pour vous assurer qu'il est en adéquation avec votre marque et le processus de réservation.",
      "update_widget_language": "Les paramètres linguistiques du widget peuvent être modifiés depuis Paramètres → Calendriers → Préférences."
    },
    "connections": {
      "google_organic_booking": "La configuration de la Redirection des rendez-vous Google permet à ce calendrier de recevoir des réservations directement depuis la recherche Google.",
      "external_sync_event": "Seul le calendrier sélectionné sous Synchronisation externe est utilisé pour récupérer et déplacer les événements de ce calendrier."
    },
    "equipments": {
      "room_definition": "Une « salle » peut représenter tout emplacement où des services sont émis. Cela pourrait être des salles physiques et/ou des stations dédiées, par exemple une station de pédicure.",
      "equipment_definition": "On entend par « Équipement » tout widget ou dispositif utilisé par les entreprises pour honorer les rendez-vous. Cela peut inclure des machines, des appareils ou même des chaises"
    }
  },
  "aria_labels": {
    "sticky_contacts": "Contacts épinglés",
    "consent_form": "Formulaire de consentement",
    "enable_guests": "Activer les invités",
    "auto_confirm": "Confirmation automatique",
    "should_accept_payment": "Devrait accepter le paiement",
    "collect_deposit": "Collecter l'acompte",
    "enable_charge_guests": "Activer les frais d'invités",
    "enable_coupon": "Activer le coupon",
    "payment_live": "Paiement en ligne",
    "add_availability_hour": "Ajouter une heure de disponibilité",
    "remove_availability_hour": "Supprimer l'heure de disponibilité",
    "copy_availability_hour": "Copier l'heure de disponibilité",
    "close_modal": "Fermer la fenêtre modale",
    "add_custom_slot": "Ajouter un créneau personnalisé",
    "remove_custom_slot": "Supprimer le créneau personnalisé",
    "edit_custom_slot": "Modifier le créneau personnalisé",
    "update_frequency": "Fréquence de mise à jour",
    "show_calendar_title": "Afficher le titre du calendrier",
    "show_calendar_description": "Afficher la description du calendrier.",
    "show_calendar_details": "Afficher les détails du calendrier",
    "allow_reschedule": "Autoriser le report",
    "allow_cancellation": "Autoriser l'annulation",
    "category_actions": "Actions de catégorie",
    "show_seats_per_slot": "Afficher les places par créneau",
    "add_more": "Ajouter plus",
    "same_user_assignment_toggle": "Bouton bascule d'attribution au même utilisateur"
  },
  "placeholders": {
    "pixel_id": "ID de pixel",
    "select_one": "Sélectionner un",
    "meeting_location": "Emplacement de la réunion",
    "schedule_meeting": "Planifier une réunion",
    "notes": "Remarque",
    "select_users": "Sélectionner des utilisateurs",
    "please_select": "Veuillez sélectionner"
  },
  "alt_text": {
    "payment_provider": "Fournisseur de services de paiement",
    "no_calendars": "Aucun calendrier",
    "date_specific_hours": "jour-heures-précis",
    "custom_widget_image": "Image du widget personnalisé",
    "service_calendar": "Calendrier de service",
    "event_calendar": "Calendrier d'événements",
    "round_robin_booking": "Réservation Round-robin",
    "class_booking": "Réservation de cours",
    "collective_booking": "Réservation groupée",
    "calendar_cover_image": "Image de couverture du calendrier",
    "email_notification_switch": "Commutateur de notification par e-mail",
    "email_template_icon": "Icône de modèle d'e-mail",
    "in_app_notification_switch": "Commutateur de notification intégré à l'application",
    "sms_notification_switch": "Commutateur de notification par SMS",
    "whatsapp_notification_switch": "Interrupteur de notification WhatsApp",
    "no_service_found": "Aucun service trouvé",
    "no_group_found": "Aucun groupe trouvé",
    "sync_icon": "Icône de synchronisation",
    "sync_type": "Type de synchronisation",
    "test1": "test1",
    "test2": "test2",
    "voice_ai_notification_switch": "Commutateur de notification Voice AI"
  },
  "tooltips": {
    "text_color": "Couleur du texte",
    "background_color": "Couleur d'arrière-plan",
    "strikethrough": "Texte barré",
    "superscript": "Exposant",
    "subscript": "Indice",
    "inline_code_block": "Bloc de code en ligne",
    "code_block": "Bloc de code",
    "block_quote": "Bloc d'estimation",
    "more": "Plus",
    "upload": "Télécharger",
    "image_upload_tooltip": "PNG, JPEG, JPG ou GIF (dimensions max. 180x180px | taille max. 2,5 Mo).",
    "custom_values": "Valeurs personnalisées",
    "text_wrap": "Habillage de texte",
    "trigger_links": "Liens de déclenchement",
    "text_align": "Alignement du texte"
  },
  "labels": {
    "reset_style": "Réinitialiser le style",
    "reset_document_style": "Réinitialiser le style du document",
    "source_code": "Code source",
    "success": "Opération réussie",
    "edit": "Modifier",
    "submit": "Enregistrer",
    "cancel": "Annuler",
    "payment": "Paiement",
    "here_is_the_link": "Voici le lien :",
    "here_is_the_embed_code": "Voici le code d'intégration :",
    "service_calendar": "Calendrier de service",
    "collective_booking": "Réservation groupée",
    "class_booking": "Réservation de cours",
    "round_robin_booking": "Réservation Round-robin",
    "event_calendar": "Calendrier d'événements",
    "personal_booking": "Réservation personnelle",
    "service_booking": "Réservation de service",
    "calendar_id": "ID de calendrier"
  },
  "validation_messages": {
    "calendar_group_name_required": "Le nom du groupe de calendriers est obligatoire.",
    "calendar_group_description_required": "La description du groupe de calendriers est obligatoire.",
    "slug_required": "Le slug est obligatoire.",
    "slug_not_valid": "Ce slug n'est pas valide.",
    "slug_already_taken": "Ce slug est déjà utilisé.",
    "error_validating_slug": "Échec lors de la validation du slug.",
    "please_enter_name": "Veuillez saisir un nom.",
    "room_name_required": "Le nom de la chambre est obligatoire",
    "equipment_name_required": "Le nom de l'équipement est obligatoire.",
    "subject_required": "Le sujet est obligatoire.",
    "this_is_required": "Ceci est requis.",
    "calendar_group_slug_required": "Le slug du groupe de calendriers est obligatoire.",
    "capacity_mandatory": "La capacité est obligatoire.",
    "capacity_cannot_be_zero": "La capacité ne peut pas être zéro.",
    "capacity_should_be_a_number": "La capacité doit être un nombre.",
    "capacity_cannot_be_negative": "La capacité ne peut pas être négative.",
    "capacity_should_be_a_whole_number": "La capacité doit être un nombre entier.",
    "quantity_mandatory": "La quantité est obligatoire",
    "quantity_cannot_be_zero": "La quantité ne peut pas être zéro.",
    "quantity_should_be_a_number": "La quantité doit être un nombre.",
    "quantity_cannot_be_negative": "La quantité ne peut pas être négative.",
    "quantity_should_be_a_whole_number": "La quantité doit être un nombre entier.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "La quantité ne peut être inférieure à celle des équipements hors service.",
    "out_of_service_value_should_be_a_number": "La valeur hors service doit être un nombre.",
    "out_of_service_cannot_be_negative": "La valeur hors service ne peut pas être négative",
    "out_of_service_equipments_qty": "La quantité d'équipements hors service ne peut pas être supérieure à la quantité réelle d'équipements.",
    "out_of_service_whole_number": "La valeur hors service doit être un nombre entier.",
    "slot_duration_required": "La durée du créneau est obligatoire.",
    "slot_duration_integer": "La durée du créneau doit être un nombre entier.",
    "meeting_duration_validation": "La durée de la réunion doit être comprise entre 1 min et 12 heures",
    "seats_class_required": "Le nombre de places par cours est obligatoire.",
    "seats_class_integer": "Le nombre de places par cours doit être un nombre entier.",
    "seats_class_validation": "Cette valeur ne peut pas être supérieure à 9999 ni inférieure à 0.",
    "meeting_location_required": "Le lieu de la réunion est obligatoire.",
    "meeting_location_empty": "Veuillez entrer une valeur pour tous les types d'emplacement.",
    "meeting_location_duplicate": "La duplication de la valeur pour le même type d'emplacement n'est pas autorisée.",
    "meeting_location_booker_multiple": "Ask the Booker n'est pas autorisé pour plusieurs membres de l'équipe."
  },
  "custom_values": {
    "assigned_user": "Utilisateur assigné",
    "full_name": "Nom complet",
    "first_name": "Prénom",
    "last_name": "Nom",
    "email": "E-mail",
    "phone": "Téléphone",
    "twilio_phone": "Téléphone Twilio",
    "account": "Compte",
    "name": "Nom",
    "full_address": "Adresse complète",
    "city": "Ville",
    "state": "État",
    "country": "Pays",
    "postal_code": "Code postal",
    "contact": "Contact",
    "address1": "Adresse 1",
    "timezone": "Fuseau horaire",
    "user": "Utilisateur",
    "appointment": "Rendez-vous",
    "start_date_time": "Date et heure de début",
    "start_date": "Date de début",
    "start_time": "Heure de début",
    "end_date_time": "Date et heure de fin",
    "end_date": "Date de fin",
    "end_time": "Heure de fin",
    "meeting_location": "Emplacement de la réunion"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Téléphone",
    "full_address": "Adresse complète",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Personnalisé"
  },
  "duration_units": {
    "minutes": "Minutes",
    "hours": "Heures"
  },
  "widget_styles": {
    "classic": "Classic",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Menu des services",
    "rooms": "Salles",
    "equipments": "Équipements"
  },
  "lsa": {
    "categories": {
      "accountant": "Comptabilité",
      "acupuncturist": "Acupuncture",
      "air_duct_cleaner": "Nettoyage des conduits d'air",
      "alcohol_treatment": "Services de traitement de l'alcoolisme",
      "animal_shelter": "Services de sauvetage animalier",
      "appliance_repair": "Réparation d’appareils électroménagers",
      "architect": "Architecture",
      "assisted_living": "Services d'aide à la personne",
      "babysitter": "Garde d'enfants",
      "bankruptcy_lawyer": "Droit de la faillite",
      "beauty_school": "École de beauté",
      "business_lawyer": "Droit des affaires",
      "car_repair": "Services automobiles",
      "carpenter": "Menuiserie",
      "carpet_cleaning": "Nettoyage de tapis",
      "child_care": "Services de garde d'enfants",
      "chiropractor": "Services de chiropraxie",
      "cleaning_service": "Nettoyage intérieur",
      "contract_lawyer": "Droit des contrats",
      "countertop_pro": "Services de plans de travail",
      "criminal_lawyer": "Droit pénal",
      "dance_instructor": "Cours de danse",
      "disability_lawyer": "Droit des personnes en situation de handicap",
      "driving_instructor": "Instructions de conduite",
      "dui_lawyer": "Loi sur la conduite",
      "electrician": "Électrique",
      "energy_efficiency_pro": "Services d'efficacité énergétique",
      "estate_lawyer": "Droit des successions",
      "event_planner": "Planification d'événements",
      "family_lawyer": "Droit de la famille",
      "fencing_pro": "Escrime",
      "financial_planner": "Planification monétaire",
      "first_aid_trainer": "Formation aux premiers secours",
      "flooring_pro": "Sol",
      "foundation_pro": "Fondations",
      "funeral_home": "Services funéraires",
      "garage_door_pro": "Porte de garage",
      "general_contractor": "Rénovation intérieure",
      "handyman": "Bricoleur",
      "home_inspector": "Inspection de maison",
      "home_security": "Services de sécurité à domicile",
      "home_theater": "Services de cinéma à domicile",
      "hvac": "CVC",
      "immigration_lawyer": "Loi sur l'immigration",
      "interior_designer": "Design d'intérieur",
      "ip_lawyer": "Droit de la propriété intellectuelle",
      "junk_removal": "Enlèvement des encombrants",
      "labor_lawyer": "Droit du travail",
      "landscaper": "Aménagement paysager",
      "language_instructor": "Éducation linguistique",
      "lawn_care": "Entretien des pelouses",
      "litigation_lawyer": "Droit des litiges",
      "locksmith": "Serrurier",
      "malpractice_lawyer": "Droit de la faute professionnelle",
      "massage_center": "Services de massage",
      "massage_school": "École de massage",
      "mover": "Déplacement",
      "nursing_home": "Service d'établissement de soins pour personnes âgées",
      "painter": "Peinture",
      "personal_injury_lawyer": "Droit des dommages corporels",
      "personal_trainer": "Entraînement personnel",
      "pest_control": "Lutte contre les nuisibles",
      "pet_adoption": "Services d'adoption d'animaux de compagnie",
      "pet_boarding": "Pension pour animaux de compagnie",
      "pet_grooming": "Toilettage pour animaux de compagnie",
      "pet_trainer": "Dressage d'animaux",
      "photographer": "Photographie",
      "plumber": "Plomberie",
      "pool_cleaner": "Nettoyage de piscine",
      "pool_contractor": "Contrats de construction de piscines",
      "preschool": "Préscolarisation",
      "psychologist": "Services de psychologie",
      "real_estate_agent": "Immobilier",
      "real_estate_lawyer": "Droit immobilier",
      "rehab": "Services de réhabilitation",
      "roofer": "Toiture",
      "sewage_pro": "Services de systèmes d'assainissement",
      "siding_pro": "Revêtement extérieur",
      "smart_home": "Services de domotique",
      "snow_removal": "Services de déneigement",
      "spa": "Services de spa",
      "tax_lawyer": "Droit fiscal",
      "tax_specialist": "Services de taxe",
      "therapist": "Thérapie",
      "towing_pro": "Assistance routière",
      "traffic_lawyer": "Droit de la circulation",
      "tree_service": "Services d'entretien des arbres",
      "tutor": "Tutorat",
      "upholstery_cleaner": "Nettoyage de tissus d'ameublement",
      "veterinarian": "Services vétérinaires",
      "videographer": "Services vidéo",
      "water_damage": "Services de réparation des dégâts d'eau",
      "weight_loss_service": "Services de perte de poids",
      "window_cleaner": "Nettoyage des fenêtres",
      "window_repair": "Services de fenêtres",
      "windshield_repair_pro": "Vitrage automobile",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Autre",
      "bankruptcy_tax_litigation": "Litige fiscal en cas de faillite",
      "bookkeeping": "Comptabilité",
      "business_consulting": "Conseil aux entreprises",
      "debt_collection_relief": "Allègement de collecte de dettes",
      "irs_representation_resolution": "Représentation et résolution de l'IRS",
      "payroll": "Paie",
      "tax_planning_business": "Planification de taxe d'entreprise",
      "tax_planning_individual": "Planification de la taxe individuelle",
      "tax_return_business": "Déclaration de taxe d'entreprise",
      "tax_return_individual": "Déclaration de taxe individuelle",
      "trusts_estates_accounting": "Comptabilité des fiducies",
      "acupressure": "Acupression",
      "acupuncture": "Acupuncture",
      "acupuncturist_other": "Autre",
      "cupping": "Cupping",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Thermothérapie",
      "herbal_therapy": "Thérapie à base de plantes",
      "infrared_therapy": "Thérapie infrarouge",
      "moxibustion": "Moxibustion",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Nettoyage des conduits d'air",
      "air_duct_filter_replacement": "Remplacement du filtre",
      "air_duct_other": "Autre",
      "dryer_vent_cleaning": "Nettoyage des conduits de sèche-linge",
      "furnace_cleaning": "Nettoyage de conduit de ventilation",
      "indoor_air_quality_testing": "Test de la qualité de l'air intérieur",
      "alcohol_treatment_other": "Autre",
      "animal_shelter_cat_adoption": "Adoption de chat",
      "animal_shelter_dog_adoption": "Adoption de chiens",
      "animal_shelter_other": "Autre",
      "animal_shelter_other_animal_adoption": "Adoption d'autres animaux",
      "animal_shelter_other_veterinary_services": "Autres services vétérinaires",
      "animal_shelter_spay_neuter": "Stérilisation ou castration",
      "animal_shelter_vaccinations": "Vaccinations",
      "lost_stray_found_animals": "Animaux perdus, errants ou trouvés",
      "pet_license": "Licence pour animaux de compagnie",
      "pet_surrender": "Abandon d'un animal de compagnie",
      "appliance_other": "Autre",
      "repair_dishwasher": "Réparation de lave-vaisselle",
      "repair_dryer": "Réparation de sèche-linge",
      "repair_freezer": "Réparer le congélateur",
      "repair_microwave": "Réparation de micro-ondes",
      "repair_oven": "Réparer le four",
      "repair_refrigerator": "Réparation de réfrigérateur",
      "repair_refrigerator_freezer": "Réparation de réfrigérateur/congélateur",
      "repair_stove_cooktop": "Réparation de cuisinière / table de cuisson",
      "repair_stove_cooktop_oven": "Réparation de cuisinière / table de cuisson / four",
      "repair_washer": "Réparation de lave-linge",
      "repair_washer_dryer": "Réparation de lave-linge / sèche-linge",
      "3d_architectural_rendering": "Rendu architectural 3D",
      "adaptive_reuse_historical_renovation": "Réutilisation adaptative et rénovation historique",
      "architect_other": "Autre",
      "architectural_designing": "Conception architecturale",
      "architectural_engineering": "Ingénierie architecturale",
      "building_code_analysis_permit_coordination": "Analyse de code et permis",
      "consulting": "Consulting",
      "home_building_improvement": "Construction et rénovation intérieure",
      "interior_design_architect": "Design d'intérieur",
      "planning_zoning_approval_assistance": "Approbation de la planification et du zonage",
      "project_managing_architect": "Gestion de projet",
      "site_master_planning": "Planification d'ensemble du site",
      "assisted_living_housekeeping_and_laundry": "Entretien ménager et blanchisserie",
      "assisted_living_meal_services": "Services de repas",
      "assisted_living_memory_care": "Soins de la mémoire",
      "assisted_living_other": "Autre",
      "assisted_living_rehabilitation_services": "Services de réadaptation",
      "assisted_living_transportation": "Transport",
      "assisted_living_wellness_programs": "Programmes de bien-être",
      "daily_living_assistance": "Assistance à la vie quotidienne",
      "medication_management": "Gestion des médicaments",
      "short_term_stays": "Séjours de courte durée",
      "social_and_recreational_activities": "Activités récréatives",
      "babysitter_other": "Autre",
      "event_babysitting": "Garde d'enfants pour événement",
      "homework_assistance": "Aide aux devoirs",
      "housekeeping_laundry": "Entretien ménager et blanchisserie",
      "meal_preparation": "Préparation des repas",
      "nanny_services": "Services de garde d'enfants",
      "overnight_babysitting": "Garde d'enfants de nuit",
      "pick_up_and_drop_off": "Ramassage et dépôt",
      "shopping_errand": "Achats et courses",
      "special_needs_care": "Soins pour personnes ayant des besoins spéciaux",
      "virtual_babysitting": "Garde d'enfants virtuelle",
      "agriculture_bankruptcy": "Faillite agricole",
      "bankruptcy_lawyer_other": "Autre",
      "bankruptcy_litigation": "Litige de faillite",
      "chapter_11_bankruptcy": "Faillite Chapter 11",
      "chapter_13_bankruptcy": "Faillite Chapter 13",
      "chapter_7_bankruptcy": "Faillite Chapter 7",
      "corporate_bankruptcy": "Faillite d'entreprise",
      "creditor_harassment": "Harcèlement par les créanciers",
      "debt_settlement": "Paiement de dettes",
      "foreclosure_bankruptcy_lawyer": "Saisie immobilière",
      "personal_bankruptcy": "Faillite personnelle",
      "repossession": "Saisie de biens",
      "wage_garnishment": "Saisie sur salaire",
      "beauty_school_barbering": "Barbier",
      "beauty_school_business_management": "Gestion d'entreprise",
      "beauty_school_cosmetology": "Cosmétologie",
      "beauty_school_esthetics": "Esthétique",
      "beauty_school_hair_cutting": "Coupe de cheveux",
      "beauty_school_hair_design": "Conception de coiffure",
      "beauty_school_makeup": "Maquillage",
      "beauty_school_massage_therapy": "Massothérapie",
      "beauty_school_nail_technology": "Technologie des ongles",
      "beauty_school_other": "Autre",
      "beauty_school_retail_training": "Formation en vente au détail",
      "banking_finance_law": "Banque et finance",
      "business_lawyer_other": "Autre",
      "business_licenses_permits": "Licences et permis d'entreprise",
      "business_litigation": "Contentieux d’entreprise",
      "business_taxes": "Taxes sur les entreprises",
      "business_transactions_business_lawyer": "Transactions d'entreprise",
      "commercial_bankruptcy": "Faillite commerciale",
      "commercial_contracts_business_lawyer": "Contrats commerciaux",
      "employment_law_business_lawyer": "Droit du travail",
      "incorporation_restructuring": "Incorporation et Restructuration",
      "insurance_law": "Droit des assurances",
      "intellectual_property_law": "Droit de la propriété intellectuelle",
      "mergers_acquisitions_business_lawyer": "Fusions et acquisitions",
      "partnership_agreements_business_lawyer": "Accords de partenariat",
      "patents_copyrights_trademarks": "Brevets, droits d'auteur et marques de commerce",
      "securities_law": "Droit des valeurs mobilières",
      "shareholder_disputes": "Litiges entre actionnaires",
      "air_and_cabin_filter": "Filtrer à air et d'habitacle",
      "battery": "Batterie",
      "body_and_trim": "Carrosserie et garniture",
      "brakes": "Freins",
      "car_air_conditioning": "Climatisation",
      "car_electrical": "Électrique",
      "car_repair_other": "Autre",
      "check_engine_light_diagnostic": "Diagnostic des voyants moteur",
      "exhaust": "Échappement",
      "oil_change": "Vidange",
      "steering_suspension": "Direction / Suspension",
      "tires": "Pneus",
      "transmission": "Transmission",
      "cabinetry": "Ébénisterie",
      "carpenter_other": "Autre",
      "decking": "Platelage",
      "drywalling": "Pose de plaques de plâtre",
      "fencing": "Clôture",
      "general_installations": "Installations générales",
      "general_repairs_maintenance": "Réparations générales et entretien",
      "remodeling": "Rénovation",
      "shelving_storage": "Rayonnage et stockage",
      "carpet_cleaning_other": "Autre",
      "clean_area_rugs": "Nettoyer les tapis",
      "clean_carpet": "Nettoyer le tapis",
      "clean_drapes_and_curtains": "Nettoyer les rideaux et les tentures",
      "clean_upholstery": "Nettoyer les tissus d'ameublement",
      "remove_pet_stains_and_odors": "Effaçage des taches et des odeurs d'animaux",
      "after_school_care": "Garde après l'école",
      "all_hours_daycare": "Garderie à toute heure",
      "bilingual_daycare": "Crèche bilingue",
      "child_care_other": "Autre",
      "drop_in_daycare": "Garderie occasionnelle",
      "full_time_daycare": "Garderie à temps plein",
      "in_home_daycare": "Garde d'enfants à domicile",
      "infant_programs": "Programmes pour nourrissons",
      "part_time_daycare": "Garde d’enfants à temps partiel",
      "pre_kindergarten_programs": "Programmes de pré-maternelle",
      "preschool_programs": "Programmes préscolaires",
      "school_age_programs": "Programmes pour enfants d'âge scolaire",
      "special_needs_daycare": "Garderie pour enfants ayant des besoins spéciaux",
      "summer_daycare": "Garde d'enfants estivale",
      "toddler_programs": "Programmes pour les tout-petits",
      "weekend_daycare": "Garde d'enfants le week-end",
      "chiropractor_acupuncture": "Acupuncture",
      "chiropractor_chiropractic": "Chiropraxie",
      "chiropractor_massage_therapy": "Thérapie de massage",
      "chiropractor_other": "Autre",
      "diagnosis": "Diagnostic",
      "eastern_medicine": "Médecine orientale",
      "exercise_counseling": "Conseil en activité physique",
      "pain_management": "Gestion des douleurs",
      "physical_therapy": "Physiothérapie",
      "spinal_adjustments": "Chiropraxie",
      "sports_medicine": "Médecine du sport",
      "cleaner_other": "Autre",
      "deep_clean": "Nettoyage en profondeur",
      "moving_clean": "Nettoyage de déménagement",
      "office_clean": "Nettoyage de bureau",
      "standard_clean": "Nettoyage normal",
      "assignment_of_contract": "Cession de contrat",
      "business_transactions_contract_lawyer": "Ventes d'entreprise",
      "commercial_contracts_contract_lawyer": "Contrats commerciaux",
      "contract_dispute": "Conflit d'accord",
      "contract_lawyer_other": "Autre",
      "contract_negotiation": "Négociation d’accord",
      "contract_review": "Révision de contrat",
      "employment_contracts_contract_lawyer": "Contrats de travail",
      "franchise_agreements": "Accords de franchise",
      "mergers_acquisitions_contract_lawyer": "Fusions et acquisitions",
      "non_disclosure_agreements_contract_lawyer": "Accords de non-divulgation",
      "partnership_agreements_contract_lawyer": "Accords de partenariat",
      "power_of_attorney_contract_lawyer": "Procuration",
      "security_agreements": "Accords de sécurité",
      "warranties": "Garanties",
      "bathroom_countertops": "Plans de travail pour salle de bain",
      "bathroom_wall_panels": "Panneaux muraux de salle de bain",
      "countertop_design": "Conception de plan de travail",
      "countertop_installation": "Installation de plan de travail",
      "countertop_pro_other": "Autre",
      "fireplace_facade": "Façade de cheminée",
      "granite_countertops": "Plans de travail en granit",
      "kitchen_countertops": "Plans de travail de cuisine",
      "kitchen_wall_panels": "Panneaux muraux de cuisine",
      "laminate_countertops": "Plans de travail en stratifié",
      "marble_countertops": "Comptoirs en marbre",
      "quartz_countertops": "Comptoirs en quartz",
      "remodeling_countertop_pro": "Rénovation",
      "repair_maintenance_countertop_pro": "Réparation et maintenance",
      "stone_slab_countertops": "Plans de travail en dalles de pierre",
      "tile_countertops": "Plans de travail en carreaux",
      "corporate_representation": "Représentation d'entreprise",
      "criminal_immigration_defense": "Défense pénale en matière d'immigration",
      "criminal_lawyer_other": "Autre",
      "domestic_violence": "Violence domestique",
      "drug_possession": "Propriété de drogue",
      "duis_reckless_driving": "Conduite en état d'ivresse et conduite imprudente",
      "expungement": "Effacement",
      "federal_crimes": "Crimes fédéraux",
      "felonies": "Crimes",
      "petty_crimes_misdemeanors": "Délits mineurs et infractions",
      "restraining_orders": "Ordonnances restrictives",
      "sex_offenses": "Infractions sexuelles",
      "three_strikes_law": "Loi des trois prises",
      "dance_instructor_african": "Africain",
      "dance_instructor_ballet": "Ballet",
      "dance_instructor_ballroom": "Salle de bal",
      "dance_instructor_belly": "Ventre",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Contemporain",
      "dance_instructor_folk_traditional": "Folk et traditionnelle",
      "dance_instructor_hip_hop": "Hip Hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Cours pour enfants",
      "dance_instructor_latin": "Latine",
      "dance_instructor_modern": "Moderne",
      "dance_instructor_other": "Autre",
      "dance_instructor_tap": "Claquettes",
      "dance_instructor_wedding": "Mariage",
      "disability_hearings": "Audiences pour personnes handicapées",
      "disability_lawyer_other": "Autre",
      "long_term_disability": "Invalidité de longue durée",
      "short_term_disability": "Invalidité de courte durée",
      "social_security_disability_insurance": "Assurance invalidité",
      "ssa_claim_reconsideration": "Réexamen de la réclamation SSA",
      "ssa_disability_appeals": "Appels d'invalidité de la SSA",
      "ssa_disability_applications": "Demande d'invalidité de la SSA",
      "ssa_disability_benefits": "Prestations d'invalidité de la SSA",
      "ssa_family_benefits": "Prestations familiales de la SSA",
      "ssa_impairment_listings": "Listes des invalidités de la SSA",
      "supplemental_security_income": "Revenu de sécurité supplémentaire",
      "veterans_disability_benefits": "Prestations d'invalidité pour anciens combattants",
      "workers_compensation_disability_lawyer": "Indemnisation des travailleurs",
      "behind_the_wheel_lessons": "Leçons de conduite",
      "commercial_license_training": "Formation à la licence commerciale",
      "defensive_driving_lessons": "Leçons de conduite défensive",
      "drivers_education_classes": "Cours d'éducation à la conduite",
      "driving_instructor_other": "Autre",
      "manual_transmission_lessons": "Leçons de transmission manuelle",
      "motorcycle_lessons": "Cours de moto",
      "traffic_school": "Auto-école",
      "dui_dwi_dui_lawyer": "Conduite sous influence/en état d'ivresse",
      "dui_injuries_dui_lawyer": "Conduite sous influence avec blessure",
      "dui_lawyer_other": "Autre",
      "dui_with_accident": "Conduite sous l'influence de l'alcool avec accident",
      "felony_dui": "Délit de conduite en état d'ivresse",
      "invalid_tests": "Tests non valides",
      "multiple_offenses": "Infractions multiples",
      "reckless_driving_dui_lawyer": "Conduite imprudente",
      "underage_dui": "Conduite en état d'ivresse par un mineur",
      "electric_car_charger": "Installation de chargeur de voiture électrique",
      "electrician_other": "Autre",
      "electrician_remodeling": "Rénovation",
      "install_fan": "Installer le ventilateur",
      "install_ground_wire": "Installation de système électrique",
      "install_light_fixtures": "Installer des luminaires",
      "install_outdoor_lighting": "Installation d'éclairage extérieur",
      "install_outlets_switches": "Installation de prises ou d'interrupteurs",
      "install_security_system": "Installer le système de sécurité",
      "relocate_outlets_switches": "Transférer les prises ou les interrupteurs",
      "repair_fan": "Réparer le ventilateur",
      "repair_light_fixtures": "Réparer les luminaires",
      "repair_outlets_switches": "Réparation des prises ou interrupteurs",
      "repair_panel": "Panneau de réparation",
      "replace_upgrade_panel": "Remplacer ou mettre à niveau le panneau",
      "restore_power": "Rétablir l'alimentation",
      "energy_efficiency_pro_other": "Autre",
      "charitable_giving": "Dons de bienfaisance",
      "contests_litigation": "Contestations / Litiges",
      "deeds": "Actes",
      "estate_lawyer_other": "Autre",
      "estate_planning_lawyer": "Planification successorale",
      "guardianship_estate_lawyer": "Tutelle",
      "medical_power_of_attorney": "Procuration médicale",
      "power_of_attorney_estate_lawyer": "Procuration",
      "probate_estate_lawyer": "Avocat spécialisé en droit des successions",
      "trusts": "Fiducies",
      "wills": "Testaments",
      "anniversary_planner": "Anniversaire",
      "baby_shower_planner": "Baby Shower",
      "bar_and_bat_mitzvah_planner": "Bar et Bat Mitzvah",
      "birthday_party": "Fête d'anniversaire",
      "children_party": "Fête pour enfants",
      "corporate_and_conference_planner": "Entreprise et conférence",
      "event_planner_other": "Autre",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Événement religieux",
      "retirement_party": "Fête de retraite",
      "school_event": "Événement scolaire",
      "theme_party": "Soirée à thème",
      "wedding_and_engagement_planner": "Mariage et fiançailles",
      "adoption": "Adoption",
      "child_support": "Pension alimentaire pour enfants",
      "contested_divorce": "Divorce contesté",
      "debt_division": "Section des dettes",
      "family_lawyer_other": "Autre",
      "guardianship_family_lawyer": "Tutelle",
      "mediation_family_lawyer": "Médiation",
      "modifications_of_orders": "Modification des ordonnances",
      "parent_timesharing": "Partage du temps parental",
      "paternity": "Paternité",
      "prenuptial_postnuptial_agreements": "Contrats prénuptiaux & accords matrimoniaux",
      "probate_family_lawyer": "Homologation",
      "property_divisions": "Partage des biens",
      "protective_orders_domestic_violence_issues": "Ordonnances de restriction",
      "spousal_support_alimony": "Pension alimentaire et soutien au conjoint",
      "uncontested_divorce": "Divorce non contesté",
      "custom_construction": "Construction personnalisée",
      "fence_design": "Design de clôture",
      "fencing_other": "Autre",
      "installation_fencing_pro": "Installation de clôture",
      "repairs_maintenance_fencing_pro": "Réparations et maintenance",
      "education_savings": "Économies pour l'éducation",
      "estate_financial_planning": "Planification successorale",
      "financial_planning": "Planification financière",
      "financial_planning_other": "Autre",
      "home_purchase": "Achat d'un bien immobilier",
      "insurance": "Assurance",
      "investment_advising": "Conseil en investissement",
      "retirement_savings": "Retraite",
      "tax_planning": "Planification de taxe",
      "advanced_cardiac_life_support": "Soins avancés de réanimation cardiaque",
      "aed_defibrillator": "DAE - Défibrillateur",
      "basic_life_support": "Soins de base en réanimation",
      "cpr": "RCP",
      "first_aid": "Premiers secours",
      "first_aid_trainer_other": "Autre",
      "pediatric_advanced_life_support": "Soins avancés en réanimation pédiatrique",
      "pediatric_cpr_first_aid": "Premiers secours pédiatriques",
      "pet_cpr_first_aid": "RCP et premiers secours pour animaux de compagnie",
      "wilderness_first_aid": "Premiers secours en milieu sauvage",
      "baseboards": "Plinthes",
      "carpet": "Tapis",
      "flooring_other": "Autre",
      "hardwood": "Bois dur",
      "installation_flooring_pro": "Installation de sols",
      "marble": "Marbre",
      "polishing": "Polissage des sols",
      "refinishing": "Rénovation des sols",
      "repair_maintenance_flooring_pro": "Réparation et entretien de sols",
      "stair_flooring": "Revêtement d'escalier",
      "tile": "Tuile",
      "wood_floor_sanding": "Ponçage des sols en bois",
      "basement_waterproofing": "Imperméabilisation des sous-sols",
      "crawl_spaces": "Fondation avec espace sanitaire",
      "foundation_drainage": "Drainage des fondations",
      "foundation_installation": "Installation des fondations",
      "foundation_pro_other": "Autre",
      "foundation_raising": "Rehaussement des fondations",
      "repairs_maintenance_foundation_pro": "Réparations et maintenance",
      "slab_foundation": "Fondation en dalle",
      "steel_pier_pilings": "Pieux en acier pour jetée",
      "water_moisture_control": "Contrôle de l’eau et de l’humidité",
      "burials": "Inhumations",
      "caskets": "Cercueils",
      "cremation": "Crémation",
      "funeral_home_flowers": "Fleurs",
      "funeral_home_other": "Autre",
      "funeral_home_transportation_transfers": "Transport et transferts",
      "funeral_home_veteran_services": "Services aux anciens combattants",
      "funerals": "Funérailles",
      "gravestones": "Pierres tombales",
      "grief_services": "Services de réclamation",
      "memorials": "Monuments commémoratifs",
      "urns": "Urnes",
      "garage_door_other": "Autre",
      "general_maintenance": "Maintenance générale",
      "install_garage_door": "Installer la porte de garage",
      "install_opener": "Installer le système d'ouverture",
      "repair_cables": "Réparer les câbles",
      "repair_garage_door": "Réparation de porte de garage",
      "repair_gate": "Réparer le portail",
      "repair_rollers_tracks": "Réparation des rouleaux et des rails",
      "replace_door_panels": "Remplacer les panneaux de porte",
      "replace_opener": "Remplacement de l'ouverture",
      "replace_springs": "Remplacement des ressorts",
      "accessory_buildings": "Bâtiments accessoires",
      "bathroom_remodel": "Rénovation de salle de bain",
      "decks_patio": "Terrasses et patios",
      "exterior_finishing": "Finition extérieure",
      "foundations_concrete": "Fondations et béton",
      "general_contractor_commercial_projects": "Projets commerciaux",
      "general_contractor_other": "Autre",
      "home_addition": "Extension de maison",
      "home_building": "Construction de maison",
      "home_remodel_renovation": "Remodelage et rénovation de maison",
      "interior_finishing": "Finition intérieure",
      "kitchen_remodel": "Rénovation de cuisine",
      "roofing": "Toiture",
      "assemble_furniture": "Assembler les meubles",
      "clean_gutters": "Nettoyage des gouttières",
      "handyman_other": "Autre",
      "install_drywall": "Installer des plaques de plâtre",
      "install_flooring": "Installer un revêtement de sol",
      "install_tile": "Pose de carrelage",
      "install_water_fixtures": "Installer des appareils sanitaires",
      "mount_tv": "Installation de télévision",
      "paint_indoors": "Peindre à l'intérieur",
      "paint_outdoors": "Peinture extérieure",
      "repair_drywall": "Réparation de placoplâtre",
      "repair_flooring": "Réparation des revêtements de sol",
      "repair_water_fixtures": "Réparation des installations d'eau",
      "replace_tile": "Remplacer la tuile",
      "buyer_seller_inspection": "Inspection acheteur-vendeur",
      "commercial_properties": "Propriétés commerciales",
      "fire_safety": "Sécurité incendie",
      "fireplace_chimney": "Foyer et cheminée",
      "full_home_inspection": "Inspection complète de maison",
      "home_inspector_electrical": "Électrique",
      "home_inspector_foundation": "Fondation",
      "home_inspector_hvac": "CVC",
      "home_inspector_mold": "Moisissure",
      "home_inspector_new_construction": "Nouvelle construction",
      "home_inspector_other": "Autre",
      "home_inspector_plumbing": "Plomberie",
      "home_inspector_roof": "Toit",
      "home_inspector_structural": "Structurel",
      "home_warranty": "Garantie résidentielle",
      "water_testing": "Test de l'eau",
      "well_or_septic_system": "Puits ou système septique",
      "wood_insects": "Bois et insectes",
      "access_control": "Contrôle d'accès",
      "alarm_systems": "Systèmes d'alarme",
      "commercial_security_systems": "Systèmes de sécurité commerciaux",
      "fire_smoke_detection": "Détection d’incendie et de fumée",
      "home_security_doors": "Portes",
      "home_security_locks": "Verrous",
      "home_security_other": "Autre",
      "home_security_windows": "Fenêtres",
      "monitoring_services": "Services de surveillance",
      "residential_security_systems": "Systèmes de sécurité résidentiels",
      "smart_home_integration": "Intégration de domotique",
      "video_surveillance": "Surveillance vidéo",
      "audio_video_installation": "Installation audio-vidéo",
      "commercial_projects": "Projets commerciaux",
      "home_theater_design": "Conception de cinéma à domicile",
      "home_theater_lighting": "Éclairage",
      "home_theater_other": "Autre",
      "home_theater_smart_home_integration": "Intégration de domotique",
      "install_tv": "Installation de télévision",
      "network_it_services": "Services système et IT",
      "outdoor_installations": "Installations extérieures",
      "soundproofing": "Insonorisation",
      "whole_house_audio_video": "Audio vidéo dans toute la maison",
      "ac_maintenance": "Maintenance de la climatisation",
      "clean_ducts_vents": "Nettoyer les conduits et les évents",
      "ductless_heating_and_ac_services": "Services de chauffage et de climatisation sans conduit",
      "heating_maintenance": "Entretien du chauffage",
      "hvac_maintenance": "Maintenance CVC",
      "hvac_other": "Autre",
      "install_ac": "Installer la climatisation",
      "install_ducts_vents": "Installation de conduits et de bouches d'aération",
      "install_heating_system": "Installer le système de chauffage",
      "install_thermostat": "Installer le thermostat",
      "repair_ac": "Réparation de la climatisation",
      "repair_ducts_vents": "Réparer les conduits et les évents",
      "repair_heating_system": "Réparation du système de chauffage",
      "repair_hvac": "Réparation CVC",
      "repair_thermostat": "Réparer le thermostat",
      "asylum": "Asile",
      "citizenship": "Citoyenneté",
      "deportation": "Déportation",
      "family_based_immigration": "Rapprochement familial",
      "green_card": "Carte verte",
      "immigration_lawyer_other": "Autre",
      "investment_visa": "Visa d'investissement",
      "outbound_work_permits": "Permis de travail extérieur",
      "student_visa": "Visa étudiant",
      "visitor_visa": "Visa de visiteur",
      "work_visa": "Visa de travail",
      "appliance_selection": "Sélection d'appareils",
      "cabinetry_molding_hardware_design": "Conception d’armoires et de quincaillerie",
      "decorating": "Décoration",
      "door_design": "Conception de porte",
      "exterior_building_design": "Design extérieur de bâtiment",
      "flooring_selection": "Sélection de revêtements de sol",
      "interior_designer_other": "Autre",
      "landscaping_design": "Aménagement paysager",
      "lighting_design": "Design d'éclairage",
      "multifamily_housing_design": "Design de logements multifamiliaux",
      "room_planning": "Conception des pièces",
      "stone_brick_stucco_design": "Design en pierre, brique et stuc",
      "window_design": "Conception de fenêtres",
      "advertisements": "Annonces",
      "copyright": "Droit d'auteur",
      "export_control": "Gestion des exportations",
      "franchises": "Franchises",
      "international_ip": "IP internationale",
      "ip_lawyer_other": "Autre",
      "ip_strategy": "Stratégie de propriété intellectuelle",
      "ip_transactions": "Transactions IP",
      "licensing": "Octroi de licences",
      "litigation_ip_lawyer": "Litige",
      "non_disclosure_agreements_ip_lawyer": "Accords de non-divulgation",
      "patents": "Brevets",
      "technology_transfer": "Transfert de technologie",
      "trade_secrets": "Secrets commerciaux",
      "trademarks": "Marques déposées",
      "appliance_removal": "Enlèvement d'appareils",
      "construction_waste_removal": "Enlèvement des déchets de construction",
      "donation_pickup": "Collecte de dons",
      "electronic_waste_removal": "Enlèvement des déchets électroniques",
      "furniture_removal": "Enlèvement de mobilier",
      "general_junk_removal": "Enlèvement général des déchets",
      "hazardous_waste_removal": "Enlèvement des déchets dangereux",
      "house_garage_cleanout": "Nettoyage de la maison/garage",
      "junk_removal_other": "Autre",
      "yard_waste_removal": "Enlèvement des déchets de jardin",
      "employment_contracts_labor_lawyer": "Contrats de travail",
      "employment_law_labor_lawyer": "Droit du travail",
      "exempt_employee_status": "Statut de salarié exonéré",
      "labor_law": "Droit du travail",
      "labor_lawyer_other": "Autre",
      "labor_negotiations": "Négociations collectives",
      "privacy_rights": "Autorisations de confidentialité",
      "sexual_harassment": "Harcèlement sexuel",
      "unpaid_overtime": "Heures supplémentaires non rémunérées",
      "whistle_blowing": "Lanceur d'alerte",
      "workers_compensation_labor_lawyer": "Indemnisation des travailleurs",
      "wrongful_termination": "Licenciement abusif",
      "artificial_turf_installation": "Installation de gazon artificiel",
      "concrete_masonry": "Maçonnerie en béton",
      "driveway_landscaping": "Aménagement paysager d'allée",
      "garden_decorations": "Décorations de jardin",
      "grading_resloping": "Nivellement et réaménagement des pentes",
      "hardscapes": "Paysagisme structurel",
      "landscape_design": "Aménagement paysager",
      "landscape_installations": "Installations de terrain",
      "landscaper_other": "Autre",
      "outdoor_steps": "Marches extérieures",
      "outdoor_water_feature": "Installations aquatiques extérieures",
      "paving_driveway_walkway": "Pavage d'allée ou de passerelle",
      "retaining_walls": "Murs de soutènement",
      "sidewalk_walkway_landscaping": "Aménagement paysager d'allée",
      "sod_seeding": "Engazonnement et ensemencement",
      "stone_masonry": "Maçonnerie en pierre",
      "arabic": "Arabe",
      "english": "English",
      "french": "Français",
      "german": "Allemand",
      "hebrew": "Hébreu",
      "italian": "Italian",
      "japanese": "Japonais",
      "korean": "Coréen",
      "language_instructor_other": "Autre",
      "mandarin": "Mandarin",
      "portuguese": "Portugais",
      "russian": "Russe",
      "sign_language": "Langue des signes",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Réparation / maintenance du système d'irrigation",
      "lawn_care_other": "Autre",
      "lawn_mowing_maintenance": "Tonte / Entretien de la pelouse",
      "lawn_pest_control": "Lutte contre les parasites de pelouse",
      "mulching": "Paillage",
      "seeding": "Ensemencement",
      "sod_installation": "Installation de gazon en plaques",
      "weed_control": "Gestion des mauvaises herbes",
      "yard_cleanup": "Nettoyage de cour",
      "appeals": "Recours",
      "case_assessment_litigation_lawyer": "Évaluation de cas",
      "civil_litigation": "Contentieux civil",
      "commercial_litigation": "Contentieux commercial",
      "contracts_and_agreements": "Contrats et accords",
      "criminal_litigation": "Procédures pénales",
      "litigation_lawyer_other": "Autre",
      "mediation_litigation_lawyer": "Médiation",
      "settlements": "Règlements",
      "building_lockout": "Confinement de bâtiment",
      "copy_building_key": "Double de clés de bâtiment",
      "copy_vehicle_key": "Copier la clé du véhicule",
      "install_hardware": "Installer le matériel",
      "locksmith_other": "Autre",
      "new_key_fob": "Nouveau porte-clés",
      "rekey_lock": "Changement de clé",
      "repair_hardware": "Réparation de matériel",
      "vehicle_lockout": "Verrouillage de véhicule",
      "consent_issues": "Problèmes de consentement",
      "diagnosis_errors": "Erreurs de diagnostic",
      "malpractice_lawyer_other": "Autre",
      "medical_negligence": "Négligence médicale",
      "treatment_errors": "Erreurs de traitement",
      "massage_center_other": "Autre",
      "massage_school_advanced_neuromuscular_therapy": "Thérapie neuromusculaire avancée",
      "massage_school_business_and_ethics": "Entreprise et éthique",
      "massage_school_clinical_therapies": "Thérapies cliniques",
      "massage_school_continuing_education": "Formation continue",
      "massage_school_deep_tissue_massage": "Massage des tissus profonds",
      "massage_school_energetics": "Énergétique",
      "massage_school_hydrotherapy": "Hydrothérapie",
      "massage_school_lymphatic_massage": "Massage lymphatique",
      "massage_school_online_massage_therapy": "Massothérapie en ligne",
      "massage_school_other": "Autre",
      "massage_school_prenatal_massage": "Massage prénatal",
      "massage_school_sports_massage": "Massage sportif",
      "massage_school_student_massage_clinic": "Clinique de massage pour étudiants",
      "massage_school_swedish_massage": "Massage suédois",
      "massage_theory": "Théorie du massage",
      "massage_therapy_training": "Cours de massothérapie",
      "in_state_move": "Déménagement intra-état",
      "local_move": "Déménagement local",
      "mover_other": "Autre",
      "moving_junk_removal": "Élimination des déchets",
      "moving_storage": "Stockage",
      "out_of_state_move": "Déménagement hors de l'État",
      "oversized_item_move": "Déplacement d'un article surdimensionné",
      "packing_unpacking": "Emballage / Déballage",
      "senior_move": "Déménagement pour seniors",
      "vehicle_transport": "Transport de véhicules",
      "cardiac_care": "Soins cardiaques",
      "general_medical_care": "Soins médicaux généraux",
      "hospice": "Hospice",
      "iv_therapy": "Thérapie intraveineuse",
      "nursing_home_meal_services": "Services de repas",
      "nursing_home_memory_care": "Soins de la mémoire",
      "nursing_home_other": "Autre",
      "nursing_home_pain_management": "Gestion de la douleur",
      "nursing_home_rehabilitation_services": "Services de réhabilitation",
      "nursing_home_wellness_programs": "Programmes de bien-être",
      "outpatient_rehabilitation": "Réhabilitation ambulatoire",
      "post_hospital_care": "Soins post-hospitaliers",
      "respiratory_and_pulmonary_care": "Soins respiratoires et pulmonaires",
      "senior_activity_programs": "Programmes d'activités pour les seniors",
      "short_term_rehabilitation": "Réhabilitation à court terme",
      "wound_care": "Soin des plaies",
      "exterior_painting": "Peinture extérieure",
      "interior_painting": "Peinture intérieure",
      "paint_cabinets": "Peindre les armoires",
      "paint_doors": "Peindre les portes",
      "painter_other": "Autre",
      "repair_water_damage": "Réparer les dégâts d'eau",
      "staining": "Teinture",
      "assault_battery": "Agression et voies de fait",
      "auto_accidents": "Accidents de voiture",
      "bicycle_accidents": "Accidents de vélo",
      "catastrophic_injuries": "Blessures catastrophiques",
      "dog_bites": "Morsures de chien",
      "dui_injuries_personal_injury_lawyer": "Blessures causées par conduite en état d'ivresse",
      "medical_malpractice": "Faute professionnelle médicale",
      "motorcycle_accidents": "Accidents de moto",
      "pain_suffering": "Douleur et souffrance",
      "pedestrian_accidents": "Accidents de piétons",
      "personal_injury_lawyer_other": "Autre",
      "product_liability": "Responsabilité du produit",
      "slip_fall": "Chute et glissade",
      "uninsured_motorist_claims": "Réclamations d'assurance pour automobilistes",
      "workers_compensation_personal_injury_lawyer": "Indemnisation des travailleurs",
      "wrongful_death": "Décès injustifié",
      "aerobics": "Aérobie",
      "athletic_performance": "Performance sportive",
      "circuit_training": "Entraînement en circuit",
      "endurance": "Endurance",
      "fitness_assessment": "Test de la condition physique",
      "hiit": "HIIT",
      "nutritional_counseling": "Conseil nutritionnel",
      "personal_trainer_other": "Autre",
      "strength_conditioning": "Renforcement et conditionnement physique",
      "weight_loss": "Perte de poids",
      "yoga": "Yoga",
      "ants": "Fourmis",
      "bed_bugs": "Punaises de lit",
      "bees": "Abeilles",
      "cockroaches": "Les cafards",
      "fleas_or_mites": "Puces ou acariens",
      "hornets_or_wasps": "Frelons ou guêpes",
      "mosquitoes": "Moustiques",
      "pest_control_other": "Autre",
      "pest_inspection": "Inspection",
      "rodents": "Rongeurs",
      "spiders": "Araignées",
      "termites": "Termites",
      "wildlife": "Faune",
      "pet_adoption_birds": "Oiseaux",
      "pet_adoption_cats": "Chats",
      "pet_adoption_dogs": "Chiens",
      "pet_adoption_farm_animals": "Animaux de ferme",
      "pet_adoption_fish": "Poisson",
      "pet_adoption_other": "Autre",
      "pet_adoption_reptiles": "Reptiles",
      "pet_adoption_small_mammals": "Petits mammifères",
      "pet_adoption_special_needs_animals": "Animaux à besoins spécifiques",
      "cat_boarding": "Pension pour chats",
      "cat_grooming": "Toilettage des chats",
      "cat_sitting_in_home": "Garde de chats (à domicile)",
      "dog_boarding": "Garde de chien",
      "dog_boarding_with_training": "Pension pour chiens avec dressage",
      "dog_daycare": "Garderie pour chiens",
      "dog_grooming": "Toilettage pour chiens",
      "dog_sitting_in_home": "Garde de chiens (à domicile)",
      "dog_training": "Dressage de chiens",
      "dog_walking": "Promenade de chiens",
      "other_pet_boarding": "Autres pensions pour animaux",
      "other_pet_daycare": "Autre garderie pour animaux",
      "other_pet_grooming": "Autre toilettage d'animaux",
      "other_pet_sitting_in_home": "Autre services de garde d’animaux (à domicile)",
      "pet_boarding_other": "Autre",
      "cat_bathing": "Toilettage pour chats",
      "cat_ear_cleaning": "Nettoyage des oreilles de chat",
      "cat_grooming_and_styling": "Toilettage et style pour chats",
      "cat_nail_trimming": "Coupe des ongles pour chats",
      "dog_anal_gland_expression": "Expression des glandes anales du chien",
      "dog_bathing_and_blow_dry": "Bain pour chien et séchage au sèche-cheveux",
      "dog_ear_cleaning": "Nettoyage des oreilles de chien",
      "dog_flea_and_tick_treatment": "Traitement anti-puces et tiques pour chiens",
      "dog_full_service_grooming": "Service complet de toilettage pour chiens",
      "dog_grooming_and_styling": "Toilettage et style pour chiens",
      "dog_nail_trimming": "Coupe des ongles de chien",
      "dog_teeth_brushing": "Nettoyage des dents de chien",
      "pet_grooming_other": "Autre",
      "aggressive_dog_training": "Dressage de chiens agressifs",
      "behavior_modification": "Modification du comportement",
      "obedience_training": "Entraînement à l'obéissance",
      "offleash_training": "Entraînement sans laisse",
      "pet_trainer_other": "Autre",
      "puppy_training": "Dressage de chiots",
      "service_animal_training": "Dressage des animaux d'assistance",
      "sport_trick_training": "Entraînement sportif ou acrobatique",
      "training_other_animals": "Dressage pour autres animaux",
      "corporate_photo": "Corporatif",
      "events_and_parties_photo": "Événements et fêtes",
      "family_and_group_photo": "Famille et groupe",
      "headshots_and_portraits": "Prises de vue et portraits",
      "individual_photo": "Personnel",
      "maternity_and_newborn_photo": "Maternité et nouveau-né",
      "photographer_other": "Autre",
      "product_photo": "Produit",
      "real_estate_photo": "Immobilier",
      "school_portraits": "Portraits scolaires",
      "wedding_and_engagement_photo": "Mariage et fiançailles",
      "find_leak": "Trouver et réparer la fuite",
      "install_faucet": "Installer un robinet",
      "install_garbage_disposal": "Installer un broyeur à déchets",
      "install_shower": "Installer une douche",
      "install_toilet": "Installation de toilettes",
      "install_water_heater": "Installation de chauffe-eau",
      "plumbing_other": "Autre",
      "repair_faucet": "Réparer le robinet",
      "repair_garbage_disposal": "Réparer le broyeur de déchets",
      "repair_outdoor_systems": "Réparer les systèmes d'extérieur",
      "repair_pipe": "Réparer le tuyau",
      "repair_sewer": "Réparer l'égout",
      "repair_shower": "Réparation de la douche",
      "repair_toilet": "Réparer les toilettes",
      "repair_water_heater": "Réparation du chauffe-eau",
      "unclog_drain": "Déboucher le drain",
      "commercial_pool_cleaning_maintenance": "Nettoyage et entretien de piscines publiques",
      "equipment_maintenance_repair": "Réparation et maintenance des équipements",
      "one_time_pool_cleaning": "Nettoyage ponctuel de la piscine",
      "ongoing_pool_cleaning": "Nettoyage régulier de la piscine",
      "pool_cleaner_other": "Autre",
      "pool_cleaner_water_features": "Installations aquatiques",
      "seasonal_opening_closing": "Ouverture et fermeture saisonnières",
      "spa_hot_tub_cleaning": "Nettoyage du spa et du bain à remous",
      "spa_hot_tub_repairs": "Réparation de spas et de bains à remous",
      "tile_pool_wall_cleaning": "Nettoyage des carreaux et des murs de piscine",
      "water_testing_balancing": "Test de l'eau et équilibrage",
      "jetted_lap_pools": "Piscine à débordement avec bain à remous",
      "pool_construction": "Construction de piscine",
      "pool_contractor_commercial_projects": "Projets commerciaux",
      "pool_contractor_custom_designs": "Conceptions personnalisées",
      "pool_contractor_other": "Autre",
      "pool_contractor_renovation": "Rénovation",
      "pool_contractor_repair_cracks": "Réparer les fissures",
      "pool_contractor_repair_tile": "Réparation du carrelage",
      "pool_contractor_resurfacing": "Resurfaçage",
      "pool_contractor_water_features": "Installations aquatiques",
      "pool_hot_tub_equipment": "Équipement de piscine et de spa",
      "spa_hot_tub_installation": "Installation de spa et de bain à remous",
      "bilingual_programs": "Programmes bilingues",
      "early_preschool": "Pré-école précoce",
      "full_day_preschool": "Pré-école à temps plein",
      "half_day_preschool": "Pré-école à mi-temps",
      "kindergarten_classes": "Maternelle",
      "montessori_programs": "Programmes Montessori",
      "play_based_preschool": "Pré-école basée sur le jeu",
      "preschool_infant_programs": "Programmes pour nourrissons",
      "preschool_other": "Autre",
      "reggio_emilia_preschool": "École maternelle Reggio Emilia",
      "special_needs_programs": "Programmes pour personnes ayant des besoins spéciaux",
      "summer_camp": "Camp d'été",
      "waldorf_preschool": "École maternelle Waldorf",
      "psychologist_other": "Autre",
      "buyer_agent": "Agent de l’acheteur",
      "first_time_home_buyer": "Primo-accédant",
      "foreclosed_properties": "Propriétés saisies",
      "luxury_properties": "Propriétés de luxe",
      "new_construction": "Nouvelle construction",
      "property_management": "Gestion des propriétés",
      "real_estate_agent_other": "Autre",
      "relocation": "Relocalisation",
      "rentals": "Locations",
      "sellers_agent": "Agent du vendeur",
      "commercial_real_estate": "Immobilier commercial",
      "easements": "Servitudes",
      "encroachment": "Intrusion",
      "foreclosure_real_esate_lawyer": "Saisie immobilière",
      "landlord_tenant_law": "Droit du propriétaire et du locataire",
      "litigation_real_estate_lawyer": "Litige",
      "mortgage_lending_law": "Droit des hypothèques et des prêts",
      "neighbor_hoa_disputes": "Litiges entre voisins et copropriétaires",
      "property_damage": "Dommages aux propriétés",
      "purchase_agreements": "Contrats d'achat",
      "real_estate_contracts_transactions": "Ventes immobilières",
      "real_estate_lawyer_other": "Autre",
      "residential_real_estate": "Immobilier",
      "title_services": "Services de titres",
      "trespassing": "Intrusion",
      "rehab_other": "Autre",
      "attic_venting": "Ventilation de grenier",
      "gutter_installation": "Installation de gouttières",
      "gutter_repair": "Réparation de gouttières",
      "roof_inspection": "Inspection de la toiture",
      "roof_installation": "Installation de toiture",
      "roof_repair": "Réparation de toiture",
      "roofer_other": "Autre",
      "skylight_installation": "Installation de puits de lumière",
      "skylight_repair": "Réparation de puits de lumière",
      "storm_wind_damage_roof_repair": "Réparation des dommages au toit",
      "sewage_cleaning": "Nettoyage",
      "sewage_excavation": "Excavation",
      "sewage_inspection": "Inspection",
      "sewage_installation": "Installation",
      "sewage_locating": "Localisation",
      "sewage_maintenance_repairs": "Maintenance et réparations",
      "sewage_pro_other": "Autre",
      "sewage_pumping": "Pompage",
      "sewage_removal_demolition": "Enlèvement ou démolition",
      "remodeling_siding_pro": "Rénovation",
      "repair_maintenance_siding_pro": "Réparation et maintenance",
      "siding_installation": "Installation de revêtement",
      "siding_pro_other": "Autre",
      "siding_removal": "Retrait de bardage",
      "smart_home_other": "Autre",
      "commercial_snow_removal": "Déneigement commercial",
      "residential_plowing": "Déneigement résidentiel",
      "residential_shoveling_blowing": "Déblaiement et soufflage résidentiels",
      "salt_sand_deicing": "Sel, sable et déglaçage",
      "snow_relocation": "Déneigement",
      "snow_removal_other": "Autre",
      "body_polish": "Gommage pour le corps",
      "body_wrap": "Enveloppement du corps",
      "facial": "Soin du visage",
      "hydrotherapy": "Hydrothérapie",
      "manicure": "Manucure",
      "massage": "Massage",
      "pedicure": "Pédicure",
      "peels": "Peelings",
      "spa_other": "Autre",
      "spa_packages": "Forfaits spa",
      "tanning": "Bronzage",
      "waxing": "Épilation à la cire",
      "civil_tax_litigation": "Contentieux fiscal civil",
      "corporate_taxes": "Taxes sur les sociétés",
      "criminal_tax_litigation": "Contentieux fiscal pénal",
      "estate_tax_planning": "Planification de la taxe successorale",
      "failure_to_file": "Défaut de document",
      "innocent_spouse_relief": "Allègement pour conjoint innocent",
      "international_tax_services": "Services de taxe internationaux",
      "irs_tax_problems": "Problèmes de taxe avec l'IRS",
      "non_collectible_status": "Statut non recouvrable",
      "offer_in_compromise": "Offre de compromis",
      "tax_audits": "Audits de taxe",
      "tax_lawyer_other": "Autre",
      "tax_liens_levies": "Privilèges de taxe et prélèvements",
      "tax_planning_lawyer": "Planification de taxe",
      "tax_relief": "Allègement de taxe",
      "accounting_support": "Assistance comptable",
      "business_incorporation_restructuring": "Incorporation et Restructuration",
      "cryptocurrency_taxes": "Taxes sur les cryptomonnaies",
      "irs_audit_representation": "Représentation d'audit fiscal (IRS)",
      "irs_filing": "Déclaration à l'IRS",
      "irs_problem_consulting": "Conseils concernant un problème (IRS)",
      "new_business_services": "Nouveaux services d'entreprise",
      "payroll_support": "Assistance pour la paie",
      "tax_planning_tax_specialist": "Planification de taxe",
      "tax_preparation": "Préparation des taxes",
      "tax_problem_consulting_tax_specialist": "Consultation pour les problèmes de taxe",
      "tax_specialist_other": "Autre",
      "therapist_other": "Autre",
      "battery_service": "Service de batterie",
      "car_towing": "Remorquage de voiture",
      "fuel_delivery": "Livraison de carburant",
      "local_hauling": "Transport local",
      "long_distance_hauling": "Transport à longue distance",
      "motorcycle_towing": "Remorquage de motos",
      "special_vehicle_towing": "Remorquage de véhicules spéciaux",
      "tire_change": "Changement de pneus",
      "towing_other": "Autre",
      "case_assessment_traffic_lawyer": "Évaluation de cas",
      "cdl_traffic_ticket": "Contravention pour permis de conduire commercial",
      "dui_dwi_traffic_lawyer": "Conduite en état d'ivresse",
      "fixit_ticket": "Injonction de réparation",
      "parking_ticket": "Ticket de stationnement",
      "reckless_driving_traffic_lawyer": "Conduite imprudente",
      "red_light_ticket": "Amende pour feu grillé",
      "speeding_ticket": "Contravention pour excès de vitesse",
      "suspended_license": "Licence suspendue",
      "traffic_lawyer_other": "Autre",
      "traffic_ticket": "Contravention routière",
      "cabling_and_bracing": "Câblage et contreventement",
      "stump_removal": "Enlèvement des souches",
      "tree_planting": "Plantation d'arbres",
      "tree_removal": "Enlèvement d'arbres",
      "tree_service_other": "Autre",
      "tree_transplanting": "Transplantation d'arbres",
      "tree_trimming_and_pruning": "Élagage et taille des arbres",
      "tutor_computer_science": "Informatique",
      "tutor_foreign_languages": "Langues étrangères",
      "tutor_geography": "Géographie",
      "tutor_government_and_economics": "Gouvernement et économie",
      "tutor_history": "Historique",
      "tutor_homework_help": "Aide aux devoirs",
      "tutor_math": "Maths",
      "tutor_other": "Autre",
      "tutor_reading_and_writing": "Lecture et écriture",
      "tutor_science": "Science",
      "tutor_special_education": "Éducation spécialisée",
      "tutor_test_pre_college_entrance": "Préparation aux tests : Entrée à l'université",
      "tutor_test_prep_grad_school_entrance": "Préparation aux tests : Admission à l'école supérieure",
      "tutor_test_prep_k8": "Préparation aux tests : K-8",
      "area_rug_cleaning": "Nettoyage de tapis",
      "drapery_and_blind_cleaning": "Nettoyage de rideaux et de stores",
      "leather_cleaning": "Nettoyage du cuir",
      "mattress_cleaning": "Nettoyage de matelas",
      "upholstery_cleaner_other": "Autre",
      "upholstery_cleaning": "Nettoyage de tissus d'ameublement",
      "upholstery_water_damage_cleanup": "Nettoyage des dégâts d’eau",
      "bird_exotic_animal_care": "Soins aux oiseaux et aux animaux exotiques",
      "farm_barn_animal_care": "Soins aux animaux de ferme et de grange",
      "microchipping": "Micropuçage",
      "veterinarian_allergies": "Allergies",
      "veterinarian_behavior_counseling": "Conseils comportementaux",
      "veterinarian_dental_care": "Soins dentaires",
      "veterinarian_dermatology": "Dermatologie",
      "veterinarian_emergency_care": "Soins d’urgence",
      "veterinarian_end_of_life_care": "Soins de fin de vie",
      "veterinarian_examinations": "Examens",
      "veterinarian_nutrition_counseling": "Conseils nutritionnels",
      "veterinarian_other": "Autre",
      "veterinarian_preventive_care": "Soins préventifs",
      "veterinarian_spay_neuter": "Stérilisation ou castration",
      "veterinarian_surgery": "Chirurgie",
      "veterinarian_vaccinations": "Vaccinations",
      "aerial_videography": "Vidéographie aérienne",
      "documentary_video_production": "Production de documentaires",
      "family_video_production": "Production de vidéos de famille",
      "live_streaming": "Diffusion en direct",
      "photography": "Photographie",
      "product_demonstrations": "Démonstration de produit",
      "promotional_video_production": "Production de vidéos promotionnelles",
      "real_estate_video_production": "Production de vidéos immobilières",
      "special_event_video_production": "Production de vidéos pour événements spéciaux",
      "video_editing": "Montage vidéo",
      "videographer_other": "Autre",
      "voice_overs": "Voix off",
      "wedding_video_production": "Production de vidéos de mariage",
      "fire_damage_cleanup_repair": "Nettoyage/réparation des dommages causés par le feu",
      "water_damage_cleanup_repair": "Nettoyage des dégâts d’eau",
      "water_damage_flooring": "Sol",
      "water_damage_mold_inspection": "Inspection de moisissure",
      "water_damage_mold_removal": "Élimination des moisissures",
      "water_damage_other": "Autre",
      "water_damage_painting": "Peinture",
      "water_damage_pest_control": "Lutte contre les nuisibles",
      "water_damage_plumbing": "Plomberie",
      "water_damage_remodeling": "Rénovation",
      "water_damage_roofing": "Toiture",
      "water_damage_sewage_cleanup": "Nettoyage des eaux usées",
      "adult_weight_loss_programs": "Programmes de perte de poids pour adultes",
      "diet_and_nutrition_counseling": "Conseils en diététique et nutrition",
      "kids_weight_loss_programs": "Programmes de perte de poids pour enfants",
      "metabolic_testing": "Tests métaboliques",
      "weight_loss_consultation_and_training": "Conseils et formation",
      "weight_loss_fitness_programs": "Programmes de remise en forme",
      "weight_loss_meal_planning": "Planification des repas",
      "weight_loss_personal_training": "Coaching personnel",
      "weight_loss_service_other": "Autre",
      "weight_loss_wellness_programs": "Programmes de bien-être",
      "glass_and_mirror_cleaning": "Nettoyage des vitres et des miroirs",
      "gutter_cleaning": "Nettoyage de gouttières",
      "power_pressure_washing": "Nettoyage haute pression",
      "rooftop_skylight_cleaning": "Nettoyage de toits/puits de lumière",
      "window_cleaner_other": "Autre",
      "window_cleaning": "Nettoyage des fenêtres",
      "door_installation": "Installation de portes",
      "door_repair": "Réparation de porte",
      "glass_installation": "Installation de vitres",
      "window_boardup": "Bardage",
      "window_installation": "Installation de fenêtres",
      "window_repair": "Réparation de fenêtres",
      "window_repair_other": "Autre",
      "install_new_wiper_blades": "Installer de nouveaux balais d'essuie-glace",
      "repair_power_window": "Réparation de fenêtre électrique",
      "repair_water_leak": "Réparer la fuite d'eau",
      "repair_windshield": "Réparation de pare-brise",
      "replace_rear_window": "Remplacement de fenêtre arrière",
      "replace_side_view_mirrors": "Réparation des rétroviseurs latéraux",
      "replace_side_window": "Remplacement de fenêtre latérale",
      "replace_sunroof": "Remplacer la vitre du toit ouvrant",
      "replace_windshield": "Remplacer le pare-brise",
      "windshield_other": "Autre",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Yoga chaud",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Méditation",
      "power_yoga": "Power Yoga",
      "restorative": "Restauratif",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Autre"
    }
  }
}
